import { t as _e } from "./module.esm-SeyKV0Gz.js";
import { t as vr } from "./queueBounce-BYbNS_fP.js";
import { t as Ee } from "./morphNodes-DmouWQ1Y.js";
import { n as Sr, r as Ir, t as Tr } from "./searchStore-DmL_oiFF.js";
var xr = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, Tn = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, Rr = (e) => e.data("addressSwitch", ({ addresses: t }) => ({
  addresses: t,
  slideTransition: Tn,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(n) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((r) => r.id === n), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), Cr = (e) => e.data("announcement", (t) => {
  const { settings: n } = t;
  return {
    current: 0,
    init() {
      n.auto_scroll && t.count > 0 && this.autoScroll(), this.$watch("current", (r) => this.autoScroll(r));
    },
    change(r) {
      this.current = r;
    },
    autoScroll(r = 0) {
      r >= t.count ? r = 0 : r += 1, setTimeout(() => this.change(r), n.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), kr = (e) => {
  e.data("backInStock", (t, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: t,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const r = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", i = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const s = await fetch(r, i);
        if (!s.ok) throw new Error("Failed to subscribe");
        if (!(await s.json()).success) throw new Error("Failed to subscribe");
      } catch (s) {
        console.error(s);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, Er = (e) => {
  e.data("cardBadges", (t) => ({
    product: t,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(n) {
      const r = this.product.additional_data || {};
      for (const i of n.keys || []) {
        const s = r[i], a = Array.isArray(s) ? s.find((o) => String(o).trim() !== "") : s;
        if (a != null && String(a).trim() !== "") return String(a).trim();
      }
      return "";
    },
    badgeLabel(n) {
      if (n.kind === "tag") return (this.product.tags || []).map((i) => String(i).trim().toLowerCase()).includes(n.tag) ? n.label : null;
      if (n.kind === "sold_out") return this.product.available === !1 ? n.label : null;
      const r = this.badgeFieldValue(n);
      return r === "" || r === "false" || r === "0" ? null : n.kind === "metafield_text" ? r : n.label;
    },
    resolveBadge() {
      for (const n of this.badgeRules) {
        const r = this.badgeLabel(n);
        if (r) return {
          ...n,
          label: r
        };
      }
      return null;
    }
  }));
}, ve = (e, t) => t instanceof e ? t : null, Or = (e, t, n = 0) => Math.min(Math.max(e, n), t), $e = {}, Nr = async (e) => {
  const t = e.toString();
  if ($e[t]) return $e[t];
  const n = await fetch(e);
  return n.ok ? ($e[t] = await n.text(), $e[t]) : null;
}, Ar = () => new Promise((e) => queueMicrotask(() => setTimeout(e, 0))), Dr = (e, t, n = 0) => (e - n) % (t - n) + n, Pr = (e) => e.data("cartDrawer", () => ({
  activeUpdates: 0,
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = e.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh, { signal: this.$abortSignal }), this.$store.cart.addEventListener("load", this.refresh, { signal: this.$abortSignal });
  },
  async refresh() {
    const t = new URL(window.location.href), n = Je();
    this.activeUpdates++, t.searchParams.set("sections", n.join(","));
    const r = await fetch(t);
    if (n.length && --this.activeUpdates == 0) {
      const i = await r.json();
      Ee(Object.values(i).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async removeItem(t) {
    await this.changeQuantity(t, 0);
  },
  async updateItem(t, n) {
    await this.changeQuantity(t, n);
  },
  async changeQuantity(t, n) {
    const r = document.querySelector(`[id="Quantity-${CSS.escape(t)}"]`), i = Number(r?.defaultValue), s = !r?.max || n <= Number(r.max), a = n === 0 || Number.isFinite(i) && n < i && s, o = Je();
    this.activeUpdates++;
    const c = await fetch(a ? "/cart/change.js" : "/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(a ? {
        id: t,
        quantity: n,
        sections: o.join(",")
      } : {
        updates: { [t]: n },
        sections: o.join(",")
      })
    });
    if (!c.ok) {
      this.activeUpdates--, await this.refresh();
      return;
    }
    if (o.length && --this.activeUpdates == 0) {
      const d = await c.json();
      Ee(Object.values(d.sections).join(""), []);
    }
  },
  async changeItem(t, n) {
    const r = Je();
    this.activeUpdates++;
    const i = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: t,
        properties: n,
        sections: r.join(",")
      })
    });
    if (r.length && --this.activeUpdates == 0) {
      const s = await i.json();
      Ee(Object.values(s.sections).join(""), []);
    }
  },
  async changeSellingPlan(t, n, r = 1) {
    const i = {
      id: t,
      selling_plan: n,
      quantity: r
    }, s = Je();
    this.activeUpdates++;
    const a = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...i,
        sections: s.join(",")
      })
    });
    if (s.length && --this.activeUpdates == 0) {
      const o = await a.json();
      Ee(Object.values(o.sections).join(""), []);
    }
  }
})), Je = () => {
  const e = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (t) => t?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(e));
}, qr = (e) => e.data("collectionFilters", (t) => ({
  ...t,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), Lr = (e) => e.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (t) => !t && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), _r = (e) => {
  e.addRootSelector(() => `[${e.prefixed("dynamic-image")}]`), e.addInitSelector(() => `[${e.prefixed("dynamic-image-broadcaster")}]`), e.directive("dynamic-image", Rn), e.directive("dynamic-image-broadcaster", Fr), e.directive("dynamic-image-image", Jr);
}, xn = /* @__PURE__ */ new WeakMap(), Rn = (e, t, { Alpine: n }) => {
  console.log("Setting up Dynamic Image Node");
  const r = xn.get(e);
  if (!r) return console.error("Dynamic Image Failed to Register: ", e, t.value);
  n.addScopeToNode(e, r);
};
Rn.inline = (e, t, { Alpine: n, cleanup: r }) => {
  console.log("Setting Dynamic Image Handler");
  const i = n.reactive({ image: null });
  xn.set(e, i);
  const s = new AbortController();
  e.closest("section")?.addEventListener("dynamic-image-update", (a) => {
    console.log("Dynamic Image receiving Event"), i.image = a.detail;
  }, { signal: s.signal }), r(s.abort.bind(s));
};
var Fr = (e, { value: t, expression: n, modifiers: r }, { Alpine: i, cleanup: s }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), t === "intersect") {
    console.log("Dynamic Image Root:", n);
    const a = new IntersectionObserver((o) => {
      for (const c of o) c.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), $r(e)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: n });
    r.includes("parent") && a.observe(e.parentElement), a.observe(e), s(a.disconnect.bind(a));
  }
}, $r = (e) => {
  e.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(e.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, Jr = (e, t, { Alpine: n, effect: r }) => {
  if (!(e instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const i = e.content;
  let s = null;
  const a = n.$data(e);
  console.log("Registering Dynamic Image Effect"), r(() => {
    if (console.log("running Dynamic Image Effect"), "image" in a && a.image) {
      const o = a.image, c = document.importNode(i, !0).firstElementChild;
      if (!(c instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (n.bind(c, {
        "x-rias"() {
          return o.url;
        },
        width: o.width,
        height: o.height,
        alt: o.alt
      }), (s ?? e).after(c), new Animation(new KeyframeEffect(c, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), s) {
        const d = new Animation(new KeyframeEffect(s, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        d.play(), d.addEventListener("finish", s.remove.bind(s));
      }
      s = c;
    }
  });
}, Mr = (e) => e == null ? [] : Array.isArray(e) ? e.map((t) => Number(t)) : typeof e == "number" && !Number.isNaN(e) ? [e] : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean).map((t) => Number(t)) : [], jr = (e) => e ? Array.isArray(e) ? e.map(String) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean) : [] : [], Br = (e) => e ? typeof e == "string" ? e : String(e) : "", Me = (e) => {
  const t = e ?? {};
  let n = Number(t.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let r = Number(t.leadTime);
  return Number.isFinite(r) || (r = 0), {
    cutOffHour: n,
    leadTime: r,
    messageHtml: Br(t.messageHtml),
    isCustomMessage: !!t.isCustomMessage,
    restrictedDays: Mr(t.restrictedDays),
    restrictedDates: jr(t.restrictedDates)
  };
}, Lt = (e) => e.dayOfWeek % 7, Ur = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], Vr = (e) => {
  let t = Math.max(0, Math.floor(e));
  const n = Math.floor(t / 86400);
  t %= 86400;
  const r = Math.floor(t / 3600);
  return t %= 3600, {
    days: n,
    hours: r,
    minutes: Math.floor(t / 60),
    seconds: t % 60
  };
}, Hr = (e) => {
  const t = e.dataset.esCfgId;
  if (!t) return Me(void 0);
  const n = document.getElementById(t);
  if (!n?.textContent?.trim()) return Me(void 0);
  try {
    const r = JSON.parse(n.textContent);
    return Me(r);
  } catch {
    return Me(void 0);
  }
}, gt = "America/Chicago", zr = (e) => {
  e.data("estimatedShipping", (t = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-ShPgAYTn.js"), Object.assign(this, Hr(this.$el), t), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const n = Temporal.Now.zonedDateTimeISO(gt), r = this.nextCutoffDate(), i = r.epochNanoseconds - n.epochNanoseconds, s = i <= 0n ? 0 : Number(i / 1000000000n), { days: a, hours: o, minutes: c, seconds: d } = Vr(s), l = [];
      (l.length || a) && l.push(a === 1 ? `${a} day` : `${a} days`), (l.length || o) && l.push(o === 1 ? `${o} hour` : `${o} hours`), (l.length || c) && l.push(c === 1 ? `${c} minute` : `${c} minutes`), (l.length || d) && l.push(d === 1 ? `${d} second` : `${d} seconds`);
      const u = this.nextShippingDate(r), p = u.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : Ur[Lt(u)];
      this.message = String(this.messageHtml).replace("%countdown%", l.join(", ")).replace("%ship_day%", p);
    },
    nextCutoffDate() {
      const n = Temporal.Now.zonedDateTimeISO(gt);
      let r = Temporal.Now.zonedDateTimeISO(gt).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(r, n) === -1 && (r = r.add({ days: 1 })); this.isDateRestricted(r); ) r = r.add({ days: 1 });
      return r;
    },
    nextShippingDate(n) {
      let r = n, i = this.leadTime;
      for (; this.isDateRestricted(r) || i > 0; )
        r = r.add({ days: 1 }), this.isDateRestricted(r) || i--;
      return r;
    },
    isDateRestricted(n) {
      if (this.restrictedDays.includes(Lt(n))) return !0;
      const r = n.toPlainDate().toString(), i = r.slice(5);
      return this.restrictedDates.some((s) => s === r || s === i);
    }
  }));
}, Kr = (e) => {
  e.data("filterController", (r) => {
    const i = [];
    return r || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await e.nextTick(), this.facetChange(!1), i.push(e.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: s }) {
        this.facetData = s ? JSON.parse(s) : this.facetChange();
        const a = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((d) => {
          d.checked = a.some(([l, u]) => l === d.name && u === d.value);
        });
        const o = a.find(([d]) => d === "sort_by")?.[1];
        if (!o) return;
        const c = document.querySelector('select[name="sort_by"]');
        c && (c.value = o);
      },
      destroy() {
        i.forEach(e.release);
      },
      _expanded: [!0],
      expanded(s) {
        return this._expanded[s];
      },
      expand(s) {
        this._expanded[s] = !this._expanded[s];
      },
      open: !1,
      fadeTransition: xr,
      slideTransition: Tn,
      facetData: [],
      facetChange(s = !0) {
        return this.facetData = Object.values(this.forms).flatMap((a) => Array.from(new FormData(a).entries())).filter(([a, o]) => !(a === "sort_by" && o === "manual" || a === "page" && (s || o === "1"))), this.facetData;
      },
      filterProducts() {
        n(this.facetData, r);
      },
      get isFiltered() {
        return this.facetData.some(([s]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(s));
      }
    };
  });
  let t = !0;
  const n = vr(async (r, i) => {
    const s = new URL(window.location.href);
    s.search = new URLSearchParams(r).toString();
    const a = await Nr(s);
    if (!a) return;
    t || Ee(a, i);
    const o = s.toString() === window.location.href;
    history[t || o ? "replaceState" : "pushState"](JSON.stringify(r), "", s.toString()), t = !1;
  });
}, Wr = (e) => {
  e.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, e.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), e.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((t) => t) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, Gr = (e) => e.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const t = this.$refs.menuDrawer;
    if (!t) return;
    const n = t.closest("section > :is(div.relative, div.absolute)");
    if (!n) return;
    const r = n.getBoundingClientRect(), i = r.y + r.height;
    this.size = `${i}px`;
  },
  adjustToLargestPart(t) {
    const n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT);
    let r = 0, i = t;
    do
      r = Math.max(r, i.scrollHeight);
    while (i = n.nextNode());
    this.size = `${r + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((t) => t.removeAttribute("open"));
  }
})), Yr = (e) => e.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (t) => {
      !t && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(t = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, t && this.$store.modal.close();
  }
})), Xr = (e) => {
  e.addRootSelector(() => `[${e.prefixed("panel-stack")}]`), e.directive("panel-stack", Zr);
}, Qr = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), Zr = (e, { expression: t }, { Alpine: n, effect: r, cleanup: i }) => {
  const s = n.reactive({ index: 0 }), a = new AbortController();
  i(a.abort.bind(a)), r(() => {
    const o = s.index;
    ei(e).forEach((c, d) => {
      c.classList.toggle("panel-current", d === o), c.classList.toggle("panel-previous", d < o), c.classList.toggle("panel-next", d > o), c.setAttribute("aria-hidden", String(d !== o));
    });
  }), queueMicrotask(() => {
    if (a.signal.aborted) return;
    const o = ni(e, t, ti(n));
    o && (ii(o, e, s, a.signal, r), ri(o, e, s, n, r)), queueMicrotask(() => e.classList.add("panels-ready"));
  });
}, ei = (e) => Array.from(e.children).filter((t) => t instanceof HTMLElement && !Qr.has(t.tagName)), Cn = (e) => {
  const t = e.prefixed("accordion");
  return `[${t}], [${t}\\.open], [${t}\\.closed]`;
}, ti = (e) => `[data-panel-trigger], ${Cn(e)}`, Tt = (e, t, n) => Array.from(e.querySelectorAll(n)).filter((r) => !t.contains(r)), ni = (e, t, n) => {
  if (t) return e.closest(t) ?? document.querySelector(t);
  let r = e.parentElement;
  for (; r; ) {
    if (Tt(r, e, n).length) return r;
    if (r.tagName === "SECTION") return null;
    r = r.parentElement;
  }
  return null;
}, ri = (e, t, n, r, i) => {
  Tt(e, t, Cn(r)).map((s) => r.evaluate(s, "$accordion")).forEach((s, a) => {
    s && i(() => {
      s.active && (n.index = a);
    });
  });
}, ii = (e, t, n, r, i) => {
  const s = Tt(e, t, "[data-panel-trigger]");
  if (!s.length) return;
  const a = s.map((o) => [o.dataset.panelTriggerTarget === "parent" ? o.parentElement ?? o : o, o.dataset.panelTrigger ?? "hover"]);
  a.forEach(([o, c], d) => {
    const l = () => {
      n.index = d;
    };
    c === "click" ? o.addEventListener("click", l, { signal: r }) : c === "hover" ? (o.addEventListener("pointerenter", l, { signal: r }), o.addEventListener("focusin", l, { signal: r })) : console.error("x-panel-trigger action: ", c, " is invalid. Use 'hover' or 'click'.");
  }), i(() => {
    const o = n.index;
    a.forEach(([c], d) => c.classList.toggle("trigger-current", d === o));
  });
}, ai = (e) => {
  e.data("productCard", (t) => ({
    variant: t,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: r, color: i } = this.variant;
      return {
        name: n,
        description: r,
        color: i
      };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, { variant: n });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    }
  }));
}, kn = class extends Error {
}, wt = /* @__PURE__ */ new Map(), si = (e) => typeof e == "string" ? e : e.name, oi = (e, t) => {
  const n = wt.get(e);
  if (n) return n;
  const r = window.Shopify?.routes?.root ?? "/", i = fetch(`${r}products/${e}?view=quickadd`).then((s) => {
    if (s.status === 404) throw new kn(e);
    if (!s.ok) throw new Error(`Quick add: ${s.status}`);
    return s.json();
  }).then((s) => ({
    optionNames: s.options.map(si),
    variants: s.variants.map((a) => ({
      id: a.id,
      options: a.options,
      available: a.available,
      price: t(a.price / 100),
      label: a.label
    }))
  }));
  return i.catch(() => wt.delete(e)), wt.set(e, i), i;
}, ci = 500, di = 5e3, li = (e) => {
  e.data("quickAdd", (t) => ({
    text: t.text,
    title: t.title,
    label: t.label,
    soldOut: t.available === !1,
    handle: t.handle ?? null,
    variants: t.variants ?? [],
    optionNames: t.optionNames ?? [],
    open: !1,
    hasPanel: (t.variants ?? []).length > 1,
    step: 0,
    picked: [],
    busy: !1,
    pendingFocus: 0,
    loading: !1,
    status: "",
    error: "",
    requestId: 0,
    loadingTimer: 0,
    statusTimer: 0,
    get panelId() {
      return `quick-add-panel-${t.blockId}-${t.uid}`;
    },
    get scopeId() {
      return `shopify-block-${t.blockId}-${t.uid}`;
    },
    get loaded() {
      return this.variants.length > 0;
    },
    get isLast() {
      return this.step === this.optionNames.length - 1;
    },
    get optionName() {
      return this.optionNames[this.step] ?? "";
    },
    get panelLabel() {
      return this.optionName ? `${this.text.choose} — ${this.optionName}` : null;
    },
    get choices() {
      const n = this.variants.filter((i) => this.picked.every((s, a) => i.options[a] === s)), r = /* @__PURE__ */ new Map();
      return n.forEach((i) => {
        const s = i.options[this.step], a = r.get(s);
        if (a) {
          i.available && !a.available && Object.assign(a, {
            available: !0,
            id: i.id,
            price: i.price,
            label: this.labelFor(i, s)
          });
          return;
        }
        r.set(s, {
          value: s,
          options: i.options,
          available: i.available,
          id: i.id,
          price: i.price,
          label: this.labelFor(i, s)
        });
      }), this.withoutCollidingLabels(Array.from(r.values()));
    },
    labelFor(n, r) {
      return this.isLast && n.label || r;
    },
    withoutCollidingLabels(n) {
      const r = /* @__PURE__ */ new Map();
      return n.forEach((i) => {
        const s = i.label.trim().toLowerCase().replace(/\s+/g, " ");
        r.set(s, (r.get(s) ?? 0) + 1);
      }), n.map((i) => {
        const s = i.label.trim().toLowerCase().replace(/\s+/g, " ");
        return (r.get(s) ?? 0) < 2 ? i : {
          ...i,
          label: i.value
        };
      });
    },
    detail(n) {
      return n.available ? this.isLast ? n.price : "" : this.text.soldOut;
    },
    get alive() {
      return !!this.$root?.isConnected;
    },
    say(n) {
      window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
        this.alive && (this.status = n, n && (this.statusTimer = window.setTimeout(() => {
          this.status = "";
        }, di)));
      });
    },
    focusMountedOption() {
      this.$nextTick(() => {
        this.alive && this.$refs.options?.querySelector("[data-quick-add-option]")?.focus();
      });
    },
    requestOptionFocus() {
      this.pendingFocus = this.requestId;
    },
    claimFocus(n) {
      this.pendingFocus && this.pendingFocus === this.requestId && this.open && this.$root?.contains(n) && (this.pendingFocus = 0, n.focus());
    },
    focusFirstOption() {
      if (this.$refs.options?.querySelector("[data-quick-add-option]")) {
        this.focusMountedOption();
        return;
      }
      this.requestOptionFocus();
    },
    reset() {
      this.step = 0, this.picked = [];
    },
    close(n) {
      this.open = !1, this.$refs.panel?.close(), this.pendingFocus = 0, this.reset(), n && this.alive && this.$refs.trigger?.focus();
    },
    back() {
      if (this.step === 0) {
        this.close(!0);
        return;
      }
      this.step = this.step - 1, this.picked = this.picked.slice(0, this.step), this.requestOptionFocus();
    },
    select(n) {
      if (n.available && this.loaded) {
        if (this.isLast) {
          this.add(n);
          return;
        }
        this.picked = this.picked.slice(0, this.step).concat(n.value), this.step = this.step + 1, this.requestOptionFocus();
      }
    },
    onEscape(n) {
      if (!this.open && !this.loading) return;
      n.stopPropagation();
      const r = this.open;
      this.requestId += 1, window.clearTimeout(this.loadingTimer), this.loading = !1, this.close(r || document.activeElement === document.body);
    },
    async ensureLoaded(n) {
      if (this.loaded) return !0;
      if (!this.handle) return !1;
      this.loading = !0, this.loadingTimer = window.setTimeout(() => {
        this.loading && this.requestId === n && this.say(this.text.loading);
      }, ci);
      try {
        const r = await oi(this.handle, this.$formatMoney);
        return this.requestId !== n || !this.alive ? !1 : (this.optionNames = r.optionNames, this.variants = r.variants, !0);
      } catch (r) {
        return this.requestId !== n || !this.alive || (r instanceof kn ? this.say(this.text.unavailable.replace("[product]", () => this.title)) : this.error = this.text.loadFailed.replace("[product]", () => this.title)), !1;
      } finally {
        window.clearTimeout(this.loadingTimer), this.loading = !1;
      }
    },
    async activate() {
      if (this.busy || this.soldOut) return;
      if (this.open) {
        this.close(!1);
        return;
      }
      this.busy = !0, this.error = "";
      const n = this.requestId += 1;
      try {
        if (!await this.ensureLoaded(n)) return;
        if (!this.variants.some((r) => r.available)) {
          this.soldOut = !0, this.say(this.text.soldOutProduct.replace("[product]", () => this.title));
          return;
        }
        if (this.variants.length === 1) {
          await this.addVariant(this.variants[0].id, this.title);
          return;
        }
        if (this.reset(), this.hasPanel = !0, await this.$nextTick(), this.requestId !== n || !this.alive) return;
        this.open = !0, this.$refs.panel?.show(), document.activeElement === this.$refs.trigger ? this.focusFirstOption() : this.say(`${this.title}. ${this.panelLabel ?? ""}`);
      } finally {
        this.busy = !1;
      }
    },
    get cart() {
      return this.$store.cart;
    },
    get itemCount() {
      return this.cart.data.item_count ?? 0;
    },
    async syncCart() {
      this.cart.data.items || (this.cart.data = await this.cart.getState());
    },
    async add(n) {
      if (!this.busy) {
        this.busy = !0;
        try {
          await this.addVariant(n.id, n.value);
        } finally {
          this.busy = !1;
        }
      }
    },
    async addVariant(n, r) {
      this.error = "", this.say(this.text.adding), await this.syncCart();
      const i = this.itemCount;
      if (await this.cart.addItem(n), !!this.alive) {
        if (this.itemCount === i) {
          this.error = this.text.failed;
          return;
        }
        this.say(this.text.added.replace("[variant]", () => r)), this.close(!0), this.cart.open();
      }
    },
    destroy() {
      window.clearTimeout(this.loadingTimer), window.clearTimeout(this.statusTimer);
    }
  }));
}, ui = (e) => {
  e.data("quickOrder", (t) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === t);
    },
    get quantity() {
      return this.productEntries.reduce((n, r) => n + r.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((n, r) => n + r.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), e.data("quickOrderRow", (t, n) => ({
    quantity: e.store("cart").items.find((r) => r.id === Number(t))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), e.data("quickQuantity", (t) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, hi = (e) => e.data("sizes", (t) => ({
  ...t,
  changeSize(n) {
    this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
  }
})), fi = (e) => {
  e.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const t = this.PDPATC.getBoundingClientRect();
      this.show = t.top < 25;
    }
  }));
}, pi = (e) => {
  e.addRootSelector(() => `[${e.prefixed("stickyheader")}]`), e.directive("stickyheader", (t, n, { cleanup: r }) => {
    console.log("checking sticky header");
    const i = t.closest("section");
    if (!i || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const s = new Animation(new KeyframeEffect(i, [{ top: "0px" }, { get top() {
      return `-${t.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    s.persist(), s.reverse(), s.finish();
    const a = e.effect(() => {
      const o = +(e.$scroll.direction === "down" && !e.$scroll.nearTop && !e.store("search").isOpen);
      s.playbackRate = o * 2 - 1;
    });
    r(() => e.release(a));
  });
}, mi = [
  Rr,
  Cr,
  Er,
  _r,
  zr,
  kr,
  Pr,
  qr,
  Lr,
  Kr,
  Wr,
  Gr,
  Yr,
  Xr,
  ai,
  li,
  ui,
  hi,
  fi,
  pi
], Xe = Math.min, me = Math.max, Qe = Math.round, je = Math.floor, oe = (e) => ({
  x: e,
  y: e
}), gi = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, wi = {
  start: "end",
  end: "start"
};
function _t(e, t, n) {
  return me(e, Xe(t, n));
}
function st(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ge(e) {
  return e.split("-")[0];
}
function ot(e) {
  return e.split("-")[1];
}
function En(e) {
  return e === "x" ? "y" : "x";
}
function On(e) {
  return e === "y" ? "height" : "width";
}
function ct(e) {
  return ["top", "bottom"].includes(ge(e)) ? "y" : "x";
}
function Nn(e) {
  return En(ct(e));
}
function yi(e, t, n) {
  n === void 0 && (n = !1);
  const r = ot(e), i = Nn(e), s = On(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = Ze(a)), [a, Ze(a)];
}
function bi(e) {
  const t = Ze(e);
  return [
    bt(e),
    t,
    bt(t)
  ];
}
function bt(e) {
  return e.replace(/start|end/g, (t) => wi[t]);
}
function vi(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], s = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? s : a;
    default:
      return [];
  }
}
function Si(e, t, n, r) {
  const i = ot(e);
  let s = vi(ge(e), n === "start", r);
  return i && (s = s.map((a) => a + "-" + i), t && (s = s.concat(s.map(bt)))), s;
}
function Ze(e) {
  return e.replace(/left|right|bottom|top/g, (t) => gi[t]);
}
function Ii(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ti(e) {
  return typeof e != "number" ? Ii(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function et(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Ft(e, t, n) {
  let { reference: r, floating: i } = e;
  const s = ct(t), a = Nn(t), o = On(a), c = ge(t), d = s === "y", l = r.x + r.width / 2 - i.width / 2, u = r.y + r.height / 2 - i.height / 2, p = r[o] / 2 - i[o] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (ot(t)) {
    case "start":
      m[a] -= p * (n && d ? -1 : 1);
      break;
    case "end":
      m[a] += p * (n && d ? -1 : 1);
  }
  return m;
}
var xi = async (e, t, n) => {
  const { placement: r = "bottom", strategy: i = "absolute", middleware: s = [], platform: a } = n, o = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let d = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), { x: l, y: u } = Ft(d, r, c), p = r, m = {}, w = 0;
  for (let v = 0; v < o.length; v++) {
    const { name: g, fn: S } = o[v], { x: k, y: N, data: L, reset: q } = await S({
      x: l,
      y: u,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: m,
      rects: d,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (l = k ?? l, u = N ?? u, m = {
      ...m,
      [g]: {
        ...m[g],
        ...L
      }
    }, q && w <= 50) {
      w++, typeof q == "object" && (q.placement && (p = q.placement), q.rects && (d = q.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : q.rects), { x: l, y: u } = Ft(d, p, c)), v = -1;
      continue;
    }
  }
  return {
    x: l,
    y: u,
    placement: p,
    strategy: i,
    middlewareData: m
  };
};
async function An(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: i, platform: s, rects: a, elements: o, strategy: c } = e, { boundary: d = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: p = !1, padding: m = 0 } = st(t, e), w = Ti(m), v = o[p ? u === "floating" ? "reference" : "floating" : u], g = et(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(v))) == null || n ? v : v.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: d,
    rootBoundary: l,
    strategy: c
  })), S = u === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, k = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), N = await (s.isElement == null ? void 0 : s.isElement(k)) ? await (s.getScale == null ? void 0 : s.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = et(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: S,
    offsetParent: k,
    strategy: c
  }) : S);
  return {
    top: (g.top - L.top + w.top) / N.y,
    bottom: (L.bottom - g.bottom + w.bottom) / N.y,
    left: (g.left - L.left + w.left) / N.x,
    right: (L.right - g.right + w.right) / N.x
  };
}
var Ri = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const { placement: i, middlewareData: s, rects: a, initialPlacement: o, platform: c, elements: d } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: p, fallbackStrategy: m = "bestFit", fallbackAxisSideDirection: w = "none", flipAlignment: v = !0, ...g } = st(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset) return {};
      const S = ge(i), k = ge(o) === o, N = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), L = p || (k || !v ? [Ze(o)] : bi(o));
      !p && w !== "none" && L.push(...Si(o, v, w, N));
      const q = [o, ...L], J = await An(t, g), C = [];
      let _ = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (l && C.push(J[S]), u) {
        const x = yi(i, a, N);
        C.push(J[x[0]], J[x[1]]);
      }
      if (_ = [..._, {
        placement: i,
        overflows: C
      }], !C.every((x) => x <= 0)) {
        var Q, ee;
        const x = (((Q = s.flip) == null ? void 0 : Q.index) || 0) + 1, h = q[x];
        if (h) return {
          data: {
            index: x,
            overflows: _
          },
          reset: { placement: h }
        };
        let f = (ee = _.filter((y) => y.overflows[0] <= 0).sort((y, T) => y.overflows[1] - T.overflows[1])[0]) == null ? void 0 : ee.placement;
        if (!f) switch (m) {
          case "bestFit": {
            var B;
            const y = (B = _.map((T) => [T.placement, T.overflows.filter((I) => I > 0).reduce((I, O) => I + O, 0)]).sort((T, I) => T[1] - I[1])[0]) == null ? void 0 : B[0];
            y && (f = y);
            break;
          }
          case "initialPlacement":
            f = o;
        }
        if (i !== f) return { reset: { placement: f } };
      }
      return {};
    }
  };
};
async function Ci(e, t) {
  const { placement: n, platform: r, elements: i } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ge(n), o = ot(n), c = ct(n) === "y", d = ["left", "top"].includes(a) ? -1 : 1, l = s && c ? -1 : 1, u = st(t, e);
  let { mainAxis: p, crossAxis: m, alignmentAxis: w } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return o && typeof w == "number" && (m = o === "end" ? w * -1 : w), c ? {
    x: m * l,
    y: p * d
  } : {
    x: p * d,
    y: m * l
  };
}
var ki = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const { x: n, y: r } = t, i = await Ci(t, e);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, Ei = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const { x: n, y: r, placement: i } = t, { mainAxis: s = !0, crossAxis: a = !1, limiter: o = { fn: (g) => {
        let { x: S, y: k } = g;
        return {
          x: S,
          y: k
        };
      } }, ...c } = st(e, t), d = {
        x: n,
        y: r
      }, l = await An(t, c), u = ct(ge(i)), p = En(u);
      let m = d[p], w = d[u];
      if (s) {
        const g = p === "y" ? "top" : "left", S = p === "y" ? "bottom" : "right", k = m + l[g], N = m - l[S];
        m = _t(k, m, N);
      }
      if (a) {
        const g = u === "y" ? "top" : "left", S = u === "y" ? "bottom" : "right", k = w + l[g], N = w - l[S];
        w = _t(k, w, N);
      }
      const v = o.fn({
        ...t,
        [p]: m,
        [u]: w
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
};
function ce(e) {
  return Dn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function re(e) {
  var t;
  return (t = (Dn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Dn(e) {
  return e instanceof Node || e instanceof G(e).Node;
}
function ne(e) {
  return e instanceof Element || e instanceof G(e).Element;
}
function Z(e) {
  return e instanceof HTMLElement || e instanceof G(e).HTMLElement;
}
function $t(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G(e).ShadowRoot;
}
function Fe(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: i } = Y(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Oi(e) {
  return [
    "table",
    "td",
    "th"
  ].includes(ce(e));
}
function xt(e) {
  const t = Rt(), n = Y(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((r) => (n.willChange || "").includes(r)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((r) => (n.contain || "").includes(r));
}
function Ni(e) {
  let t = xe(e);
  for (; Z(t) && !dt(t); ) {
    if (xt(t)) return t;
    t = xe(t);
  }
  return null;
}
function Rt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function dt(e) {
  return [
    "html",
    "body",
    "#document"
  ].includes(ce(e));
}
function Y(e) {
  return G(e).getComputedStyle(e);
}
function lt(e) {
  return ne(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function xe(e) {
  if (ce(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || $t(e) && e.host || re(e);
  return $t(t) ? t.host : t;
}
function Pn(e) {
  const t = xe(e);
  return dt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Z(t) && Fe(t) ? t : Pn(t);
}
function De(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Pn(e), s = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = G(i);
  return s ? t.concat(a, a.visualViewport || [], Fe(i) ? i : [], a.frameElement && n ? De(a.frameElement) : []) : t.concat(i, De(i, [], n));
}
function qn(e) {
  const t = Y(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Z(e), s = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, o = Qe(n) !== s || Qe(r) !== a;
  return o && (n = s, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function Ct(e) {
  return ne(e) ? e : e.contextElement;
}
function Te(e) {
  const t = Ct(e);
  if (!Z(t)) return oe(1);
  const n = t.getBoundingClientRect(), { width: r, height: i, $: s } = qn(t);
  let a = (s ? Qe(n.width) : n.width) / r, o = (s ? Qe(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
var Ai = /* @__PURE__ */ oe(0);
function Ln(e) {
  const t = G(e);
  return !Rt() || !t.visualViewport ? Ai : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Di(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== G(e) ? !1 : t;
}
function we(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), s = Ct(e);
  let a = oe(1);
  t && (r ? ne(r) && (a = Te(r)) : a = Te(e));
  const o = Di(s, n, r) ? Ln(s) : oe(0);
  let c = (i.left + o.x) / a.x, d = (i.top + o.y) / a.y, l = i.width / a.x, u = i.height / a.y;
  if (s) {
    const p = G(s), m = r && ne(r) ? G(r) : r;
    let w = p.frameElement;
    for (; w && r && m !== p; ) {
      const v = Te(w), g = w.getBoundingClientRect(), S = Y(w), k = g.left + (w.clientLeft + parseFloat(S.paddingLeft)) * v.x, N = g.top + (w.clientTop + parseFloat(S.paddingTop)) * v.y;
      c *= v.x, d *= v.y, l *= v.x, u *= v.y, c += k, d += N, w = G(w).frameElement;
    }
  }
  return et({
    width: l,
    height: u,
    x: c,
    y: d
  });
}
function Pi(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const i = Z(n), s = re(n);
  if (n === s) return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = oe(1);
  const c = oe(0);
  if ((i || !i && r !== "fixed") && ((ce(n) !== "body" || Fe(s)) && (a = lt(n)), Z(n))) {
    const d = we(n);
    o = Te(n), c.x = d.x + n.clientLeft, c.y = d.y + n.clientTop;
  }
  return {
    width: t.width * o.x,
    height: t.height * o.y,
    x: t.x * o.x - a.scrollLeft * o.x + c.x,
    y: t.y * o.y - a.scrollTop * o.y + c.y
  };
}
function qi(e) {
  return Array.from(e.getClientRects());
}
function _n(e) {
  return we(re(e)).left + lt(e).scrollLeft;
}
function Li(e) {
  const t = re(e), n = lt(e), r = e.ownerDocument.body, i = me(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = me(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + _n(e);
  const o = -n.scrollTop;
  return Y(r).direction === "rtl" && (a += me(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: s,
    x: a,
    y: o
  };
}
function _i(e, t) {
  const n = G(e), r = re(e), i = n.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, o = 0, c = 0;
  if (i) {
    s = i.width, a = i.height;
    const d = Rt();
    (!d || d && t === "fixed") && (o = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: o,
    y: c
  };
}
function Fi(e, t) {
  const n = we(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, s = Z(e) ? Te(e) : oe(1);
  return {
    width: e.clientWidth * s.x,
    height: e.clientHeight * s.y,
    x: i * s.x,
    y: r * s.y
  };
}
function Jt(e, t, n) {
  let r;
  if (t === "viewport") r = _i(e, n);
  else if (t === "document") r = Li(re(e));
  else if (ne(t)) r = Fi(t, n);
  else {
    const i = Ln(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return et(r);
}
function Fn(e, t) {
  const n = xe(e);
  return n === t || !ne(n) || dt(n) ? !1 : Y(n).position === "fixed" || Fn(n, t);
}
function $i(e, t) {
  const n = t.get(e);
  if (n) return n;
  let r = De(e, [], !1).filter((o) => ne(o) && ce(o) !== "body"), i = null;
  const s = Y(e).position === "fixed";
  let a = s ? xe(e) : e;
  for (; ne(a) && !dt(a); ) {
    const o = Y(a), c = xt(a);
    !c && o.position === "fixed" && (i = null), (s ? !c && !i : !c && o.position === "static" && i && ["absolute", "fixed"].includes(i.position) || Fe(a) && !c && Fn(e, a)) ? r = r.filter((d) => d !== a) : i = o, a = xe(a);
  }
  return t.set(e, r), r;
}
function Ji(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: i } = e;
  const s = [...n === "clippingAncestors" ? $i(t, this._c) : [].concat(n), r], a = s[0], o = s.reduce((c, d) => {
    const l = Jt(t, d, i);
    return c.top = me(l.top, c.top), c.right = Xe(l.right, c.right), c.bottom = Xe(l.bottom, c.bottom), c.left = me(l.left, c.left), c;
  }, Jt(t, a, i));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function Mi(e) {
  return qn(e);
}
function ji(e, t, n) {
  const r = Z(t), i = re(t), s = n === "fixed", a = we(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = oe(0);
  if (r || !r && !s)
    if ((ce(t) !== "body" || Fe(i)) && (o = lt(t)), r) {
      const d = we(t, !0, s, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else i && (c.x = _n(i));
  return {
    x: a.left + o.scrollLeft - c.x,
    y: a.top + o.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function Mt(e, t) {
  return !Z(e) || Y(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function $n(e, t) {
  const n = G(e);
  if (!Z(e)) return n;
  let r = Mt(e, t);
  for (; r && Oi(r) && Y(r).position === "static"; ) r = Mt(r, t);
  return r && (ce(r) === "html" || ce(r) === "body" && Y(r).position === "static" && !xt(r)) ? n : r || Ni(e) || n;
}
var Bi = async function(e) {
  let { reference: t, floating: n, strategy: r } = e;
  const i = this.getOffsetParent || $n, s = this.getDimensions;
  return {
    reference: ji(t, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await s(n)
    }
  };
};
function Ui(e) {
  return Y(e).direction === "rtl";
}
var Vi = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Pi,
  getDocumentElement: re,
  getClippingRect: Ji,
  getOffsetParent: $n,
  getElementRects: Bi,
  getClientRects: qi,
  getDimensions: Mi,
  getScale: Te,
  isElement: ne,
  isRTL: Ui
};
function Hi(e, t) {
  let n = null, r;
  const i = re(e);
  function s() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(o, c) {
    o === void 0 && (o = !1), c === void 0 && (c = 1), s();
    const { left: d, top: l, width: u, height: p } = e.getBoundingClientRect();
    if (o || t(), !u || !p) return;
    const m = je(l), w = je(i.clientWidth - (d + u)), v = je(i.clientHeight - (l + p)), g = je(d), S = {
      rootMargin: -m + "px " + -w + "px " + -v + "px " + -g + "px",
      threshold: me(0, Xe(1, c)) || 1
    };
    let k = !0;
    function N(L) {
      const q = L[0].intersectionRatio;
      if (q !== c) {
        if (!k) return a();
        q ? a(!1, q) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(N, {
        ...S,
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(N, S);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function zi(e, t, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: i = !0, ancestorResize: s = !0, elementResize: a = typeof ResizeObserver == "function", layoutShift: o = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, d = Ct(e), l = i || s ? [...d ? De(d) : [], ...De(t)] : [];
  l.forEach((S) => {
    i && S.addEventListener("scroll", n, { passive: !0 }), s && S.addEventListener("resize", n);
  });
  const u = d && o ? Hi(d, n) : null;
  let p = -1, m = null;
  a && (m = new ResizeObserver((S) => {
    let [k] = S;
    k && k.target === d && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      m && m.observe(t);
    })), n();
  }), d && !c && m.observe(d), m.observe(t));
  let w, v = c ? we(e) : null;
  c && g();
  function g() {
    const S = we(e);
    v && (S.x !== v.x || S.y !== v.y || S.width !== v.width || S.height !== v.height) && n(), v = S, w = requestAnimationFrame(g);
  }
  return n(), () => {
    l.forEach((S) => {
      i && S.removeEventListener("scroll", n), s && S.removeEventListener("resize", n);
    }), u && u(), m && m.disconnect(), m = null, c && cancelAnimationFrame(w);
  };
}
var Ki = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Vi,
    ...n
  }, s = {
    ...i.platform,
    _c: r
  };
  return xi(e, t, {
    ...i,
    platform: s
  });
};
function Wi(e) {
  e.magic("anchor", (t) => {
    if (!t._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return t._x_anchor;
  }), e.interceptClone((t, n) => {
    t && t._x_anchor && !n._x_anchor && (n._x_anchor = t._x_anchor);
  }), e.directive("anchor", e.skipDuringClone((t, { expression: n, modifiers: r, value: i }, { evaluate: s, effect: a, cleanup: o }) => {
    let { placement: c, offsetValue: d, unstyled: l, strategy: u, allowFlip: p } = Bt(r);
    t._x_anchor = e.reactive({
      x: 0,
      y: 0
    });
    let m = null, w = null;
    a(() => {
      let v = s(n);
      if (v && m !== v) {
        w && w(), m = v;
        let g = () => {
          let S;
          Ki(v, t, {
            placement: c,
            strategy: u,
            middleware: [
              p && Ri(),
              Ei({ padding: 5 }),
              ki(d)
            ]
          }).then(({ x: k, y: N }) => {
            l || jt(t, k, N, u), JSON.stringify({
              x: k,
              y: N
            }) !== S && (t._x_anchor.x = k, t._x_anchor.y = N), S = JSON.stringify({
              x: k,
              y: N
            });
          });
        };
        w = zi(v, t, () => g());
      }
    }), o(() => {
      w && w();
    });
  }, (t, { expression: n, modifiers: r, value: i }, { cleanup: s, evaluate: a }) => {
    let { placement: o, offsetValue: c, unstyled: d, strategy: l } = Bt(r);
    t._x_anchor && (d || jt(t, t._x_anchor.x, t._x_anchor.y, l));
  }));
}
function jt(e, t, n, r = "absolute") {
  Object.assign(e.style, {
    left: t + "px",
    top: n + "px",
    position: r
  });
}
function Bt(e) {
  let t = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((a) => e.includes(a)), n = 0;
  if (e.includes("offset")) {
    let a = e.findIndex((o) => o === "offset");
    n = e[a + 1] !== void 0 ? Number(e[a + 1]) : n;
  }
  let r = e.includes("no-style"), i = !e.includes("noflip"), s = e.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: t,
    offsetValue: n,
    unstyled: r,
    strategy: s,
    allowFlip: i
  };
}
var Gi = Wi;
function Yi(e) {
  e.directive("collapse", t), t.inline = (n, { modifiers: r }) => {
    r.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function t(n, { modifiers: r }) {
    let i = Ut(r, "duration", 250) / 1e3, s = Ut(r, "min", 0), a = !r.includes("min");
    n._x_isShown || (n.style.height = `${s}px`), !n._x_isShown && a && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let o = (d, l) => {
      let u = e.setStyles(d, l);
      return l.height ? () => {
      } : u;
    }, c = {
      transitionProperty: "height",
      transitionDuration: `${i}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(d = () => {
      }, l = () => {
      }) {
        a && (n.hidden = !1), a && (n.style.display = null);
        let u = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let p = n.getBoundingClientRect().height;
        u === p && (u = s), e.transition(n, e.setStyles, {
          during: c,
          start: { height: u + "px" },
          end: { height: p + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - p) < 1 && (n.style.overflow = null);
        });
      },
      out(d = () => {
      }, l = () => {
      }) {
        let u = n.getBoundingClientRect().height;
        e.transition(n, o, {
          during: c,
          start: { height: u + "px" },
          end: { height: s + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${s}px` && a && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function Ut(e, t, n) {
  if (e.indexOf(t) === -1) return n;
  const r = e[e.indexOf(t) + 1];
  if (!r) return n;
  if (t === "duration") {
    let i = r.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  if (t === "min") {
    let i = r.match(/([0-9]+)px/);
    if (i) return i[1];
  }
  return r;
}
var Xi = Yi, Jn = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], tt = /* @__PURE__ */ Jn.join(","), Mn = typeof Element > "u", ye = Mn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, nt = !Mn && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, rt = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert");
  return i === "" || i === "true" || n && t && (typeof t.closest == "function" ? t.closest("[inert]") : rt(t.parentNode));
}, Qi = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, jn = function(t, n, r) {
  if (rt(t)) return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(tt));
  return n && ye.call(t, tt) && i.unshift(t), i = i.filter(r), i;
}, it = function(t, n, r) {
  for (var i = [], s = Array.from(t); s.length; ) {
    var a = s.shift();
    if (!rt(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), c = it(o.length ? o : a.children, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        ye.call(a, tt) && r.filter(a) && (n || !t.includes(a)) && i.push(a);
        var d = a.shadowRoot || typeof r.getShadowRoot == "function" && r.getShadowRoot(a), l = !rt(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && l) {
          var u = it(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, u) : i.push({
            scopeParent: a,
            candidates: u
          });
        } else s.unshift.apply(s, a.children);
      }
  }
  return i;
}, Bn = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pe = function(t) {
  if (!t) throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Qi(t)) && !Bn(t) ? 0 : t.tabIndex;
}, Zi = function(t, n) {
  var r = pe(t);
  return r < 0 && n && !Bn(t) ? 0 : r;
}, ea = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Un = function(t) {
  return t.tagName === "INPUT";
}, ta = function(t) {
  return Un(t) && t.type === "hidden";
}, na = function(t) {
  return t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
}, ra = function(t, n) {
  for (var r = 0; r < t.length; r++) if (t[r].checked && t[r].form === n) return t[r];
}, ia = function(t) {
  if (!t.name) return !0;
  var n = t.form || nt(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") i = r(window.CSS.escape(t.name));
  else try {
    i = r(t.name);
  } catch (a) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
  }
  var s = ra(i, t.form);
  return !s || s === t;
}, aa = function(t) {
  return Un(t) && t.type === "radio";
}, sa = function(t) {
  return aa(t) && !ia(t);
}, oa = function(t) {
  var n, r = t && nt(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, s = !1;
  if (r && r !== t) {
    var a, o, c;
    for (s = !!((a = i) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(i) || t != null && (c = t.ownerDocument) !== null && c !== void 0 && c.contains(t)); !s && i; ) {
      var d, l, u;
      r = nt(i), i = (d = r) === null || d === void 0 ? void 0 : d.host, s = !!((l = i) !== null && l !== void 0 && (u = l.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return s;
}, Vt = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, ca = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t)
    return !t.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(t).visibility === "hidden") return !0;
  var s = ye.call(t, "details>summary:first-of-type") ? t.parentElement : t;
  if (ye.call(s, "details:not([open]) *")) return !0;
  if (!r || r === "full" || r === "full-native" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var a = t; t; ) {
        var o = t.parentElement, c = nt(t);
        if (o && !o.shadowRoot && i(o) === !0) return Vt(t);
        t.assignedSlot ? t = t.assignedSlot : !o && c !== t.ownerDocument ? t = c.host : t = o;
      }
      t = a;
    }
    if (oa(t)) return !t.getClientRects().length;
    if (r !== "legacy-full") return !0;
  } else if (r === "non-zero-area") return Vt(t);
  return !1;
}, da = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND") return ye.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, at = function(t, n) {
  return !(n.disabled || ta(n) || ca(n, t) || na(n) || da(n));
}, vt = function(t, n) {
  return !(sa(n) || pe(n) < 0 || !at(t, n));
}, la = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Vn = function(t) {
  var n = [], r = [];
  return t.forEach(function(i, s) {
    var a = !!i.scopeParent, o = a ? i.scopeParent : i, c = Zi(o, a), d = a ? Vn(i.candidates) : o;
    c === 0 ? a ? n.push.apply(n, d) : n.push(o) : r.push({
      documentOrder: s,
      tabIndex: c,
      item: i,
      isScope: a,
      content: d
    });
  }), r.sort(ea).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(n);
}, ua = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = it([t], n.includeContainer, {
    filter: vt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: la
  }) : r = jn(t, n.includeContainer, vt.bind(null, n)), Vn(r);
}, Hn = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = it([t], n.includeContainer, {
    filter: at.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = jn(t, n.includeContainer, at.bind(null, n)), r;
}, Se = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return ye.call(t, tt) === !1 ? !1 : vt(n, t);
}, ha = /* @__PURE__ */ Jn.concat("iframe:not([inert]):not([inert] *)").join(","), ze = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return ye.call(t, ha) === !1 ? !1 : at(n, t);
};
function St(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function fa(e) {
  if (Array.isArray(e)) return St(e);
}
function Ht(e, t, n, r, i, s, a) {
  try {
    var o = e[s](a), c = o.value;
  } catch (d) {
    n(d);
    return;
  }
  o.done ? t(c) : Promise.resolve(c).then(r, i);
}
function zt(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var s = e.apply(t, n);
      function a(c) {
        Ht(s, r, i, a, o, "next", c);
      }
      function o(c) {
        Ht(s, r, i, a, o, "throw", c);
      }
      a(void 0);
    });
  };
}
function Kt(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = zn(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? { done: !0 } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, a = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return a = c.done, c;
    },
    e: function(c) {
      o = !0, s = c;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (o) throw s;
      }
    }
  };
}
function pa(e, t, n) {
  return (t = ba(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ma(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ga() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wt(Object(n), !0).forEach(function(r) {
      pa(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Oe() {
  var e, t, n = typeof Symbol == "function" ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
  function s(m, w, v, g) {
    var S = w && w.prototype instanceof o ? w : o, k = Object.create(S.prototype);
    return W(k, "_invoke", (function(N, L, q) {
      var J, C, _, Q = 0, ee = q || [], B = !1, x = {
        p: 0,
        n: 0,
        v: e,
        a: h,
        f: h.bind(e, 4),
        d: function(f, y) {
          return J = f, C = 0, _ = e, x.n = y, a;
        }
      };
      function h(f, y) {
        for (C = f, _ = y, t = 0; !B && Q && !T && t < ee.length; t++) {
          var T, I = ee[t], O = x.p, R = I[2];
          f > 3 ? (T = R === y) && (_ = I[(C = I[4]) ? 5 : (C = 3, 3)], I[4] = I[5] = e) : I[0] <= O && ((T = f < 2 && O < I[1]) ? (C = 0, x.v = y, x.n = I[1]) : O < R && (T = f < 3 || I[0] > y || y > R) && (I[4] = f, I[5] = y, x.n = R, C = 0));
        }
        if (T || f > 1) return a;
        throw B = !0, y;
      }
      return function(f, y, T) {
        if (Q > 1) throw TypeError("Generator is already running");
        for (B && y === 1 && h(y, T), C = y, _ = T; (t = C < 2 ? e : _) || !B; ) {
          J || (C ? C < 3 ? (C > 1 && (x.n = -1), h(C, _)) : x.n = _ : x.v = _);
          try {
            if (Q = 2, J) {
              if (C || (f = "next"), t = J[f]) {
                if (!(t = t.call(J, _))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                _ = t.value, C < 2 && (C = 0);
              } else C === 1 && (t = J.return) && t.call(J), C < 2 && (_ = TypeError("The iterator does not provide a '" + f + "' method"), C = 1);
              J = e;
            } else if ((t = (B = x.n < 0) ? _ : N.call(L, x)) !== a) break;
          } catch (I) {
            J = e, C = 1, _ = I;
          } finally {
            Q = 1;
          }
        }
        return {
          value: t,
          done: B
        };
      };
    })(m, v, g), !0), k;
  }
  var a = {};
  function o() {
  }
  function c() {
  }
  function d() {
  }
  t = Object.getPrototypeOf;
  var l = [][r] ? t(t([][r]())) : (W(t = {}, r, function() {
    return this;
  }), t), u = d.prototype = o.prototype = Object.create(l);
  function p(m) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(m, d) : (m.__proto__ = d, W(m, i, "GeneratorFunction")), m.prototype = Object.create(u), m;
  }
  return c.prototype = d, W(u, "constructor", d), W(d, "constructor", c), c.displayName = "GeneratorFunction", W(d, i, "GeneratorFunction"), W(u), W(u, i, "Generator"), W(u, r, function() {
    return this;
  }), W(u, "toString", function() {
    return "[object Generator]";
  }), (Oe = function() {
    return {
      w: s,
      m: p
    };
  })();
}
function W(e, t, n, r) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  W = function(s, a, o, c) {
    function d(l, u) {
      W(s, l, function(p) {
        return this._invoke(l, u, p);
      });
    }
    a ? i ? i(s, a, {
      value: o,
      enumerable: !c,
      configurable: !c,
      writable: !c
    }) : s[a] = o : (d("next", 0), d("throw", 1), d("return", 2));
  }, W(e, t, n, r);
}
function wa(e) {
  return fa(e) || ma(e) || zn(e) || ga();
}
function ya(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ba(e) {
  var t = ya(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function zn(e, t) {
  if (e) {
    if (typeof e == "string") return St(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? St(e, t) : void 0;
  }
}
var te = {
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  activateTrap: function(t, n) {
    n !== te.getActiveTrap(t) && te.pauseTrap(t);
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), te.unpauseTrap(t);
  },
  pauseTrap: function(t) {
    var n = te.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  unpauseTrap: function(t) {
    var n = te.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, va = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Sa = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, Ae = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Ia = function(t) {
  return Ae(t) && !t.shiftKey;
}, Ta = function(t) {
  return Ae(t) && t.shiftKey;
}, Yt = function(t) {
  return setTimeout(t, 0);
}, Re = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Be = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, xa = [], Ra = function(t, n) {
  var r = n?.document || document, i = n?.trapStack || xa, s = Gt({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Ia,
    isKeyBackward: Ta
  }, n), a = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, o, c = function(h, f, y) {
    return h && h[f] !== void 0 ? h[f] : s[y || f];
  }, d = function(h, f) {
    var y = typeof f?.composedPath == "function" ? f.composedPath() : void 0;
    return a.containerGroups.findIndex(function(T) {
      var I = T.container, O = T.tabbableNodes;
      return I.contains(h) || y?.includes(I) || O.find(function(R) {
        return R === h;
      });
    });
  }, l = function(h) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = f.hasFallback, T = y === void 0 ? !1 : y, I = f.params, O = I === void 0 ? [] : I, R = s[h];
    if (typeof R == "function" && (R = R.apply(void 0, wa(O))), R === !0 && (R = void 0), !R) {
      if (R === void 0 || R === !1) return R;
      throw new Error("`".concat(h, "` was specified but was not a node, or did not return a node"));
    }
    var E = R;
    if (typeof R == "string") {
      try {
        E = r.querySelector(R);
      } catch (P) {
        throw new Error("`".concat(h, '` appears to be an invalid selector; error="').concat(P.message, '"'));
      }
      if (!E && !T)
        throw new Error("`".concat(h, "` as selector refers to no known node"));
    }
    return E;
  }, u = function() {
    var h = l("initialFocus", { hasFallback: !0 });
    if (h === !1) return !1;
    if (h === void 0 || h && !ze(h, s.tabbableOptions))
      if (d(r.activeElement) >= 0) h = r.activeElement;
      else {
        var f = a.tabbableGroups[0];
        h = f && f.firstTabbableNode || l("fallbackFocus");
      }
    else h === null && (h = l("fallbackFocus"));
    if (!h) throw new Error("Your focus-trap needs to have at least one focusable element");
    return h;
  }, p = function() {
    if (a.containerGroups = a.containers.map(function(h) {
      var f = ua(h, s.tabbableOptions), y = Hn(h, s.tabbableOptions), T = f.length > 0 ? f[0] : void 0, I = f.length > 0 ? f[f.length - 1] : void 0, O = y.find(function(E) {
        return Se(E);
      }), R = y.slice().reverse().find(function(E) {
        return Se(E);
      });
      return {
        container: h,
        tabbableNodes: f,
        focusableNodes: y,
        posTabIndexesFound: !!f.find(function(E) {
          return pe(E) > 0;
        }),
        firstTabbableNode: T,
        lastTabbableNode: I,
        firstDomTabbableNode: O,
        lastDomTabbableNode: R,
        nextTabbableNode: function(P) {
          var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, H = f.indexOf(P);
          return H < 0 ? V ? y.slice(y.indexOf(P) + 1).find(function(j) {
            return Se(j);
          }) : y.slice(0, y.indexOf(P)).reverse().find(function(j) {
            return Se(j);
          }) : f[H + (V ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(h) {
      return h.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !l("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(h) {
      return h.posTabIndexesFound;
    }) && a.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, m = function(h) {
    var f = h.activeElement;
    if (f)
      return f.shadowRoot && f.shadowRoot.activeElement !== null ? m(f.shadowRoot) : f;
  }, w = function(h) {
    if (h !== !1 && h !== m(document)) {
      if (!h || !h.focus) {
        w(u());
        return;
      }
      h.focus({ preventScroll: !!s.preventScroll }), a.mostRecentlyFocusedNode = h, va(h) && h.select();
    }
  }, v = function(h) {
    var f = l("setReturnFocus", { params: [h] });
    return f || (f === !1 ? !1 : h);
  }, g = function(h) {
    var f = h.target, y = h.event, T = h.isBackward, I = T === void 0 ? !1 : T;
    f = f || Be(y), p();
    var O = null;
    if (a.tabbableGroups.length > 0) {
      var R = d(f, y), E = R >= 0 ? a.containerGroups[R] : void 0;
      if (R < 0)
        I ? O = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : O = a.tabbableGroups[0].firstTabbableNode;
      else if (I) {
        var P = a.tabbableGroups.findIndex(function(pt) {
          var mt = pt.firstTabbableNode;
          return f === mt;
        });
        if (P < 0 && (E.container === f || ze(f, s.tabbableOptions) && !Se(f, s.tabbableOptions) && !E.nextTabbableNode(f, !1)) && (P = R), P >= 0) {
          var V = P === 0 ? a.tabbableGroups.length - 1 : P - 1, H = a.tabbableGroups[V];
          O = pe(f) >= 0 ? H.lastTabbableNode : H.lastDomTabbableNode;
        } else Ae(y) || (O = E.nextTabbableNode(f, !1));
      } else {
        var j = a.tabbableGroups.findIndex(function(pt) {
          var mt = pt.lastTabbableNode;
          return f === mt;
        });
        if (j < 0 && (E.container === f || ze(f, s.tabbableOptions) && !Se(f, s.tabbableOptions) && !E.nextTabbableNode(f)) && (j = R), j >= 0) {
          var ft = j === a.tabbableGroups.length - 1 ? 0 : j + 1, ie = a.tabbableGroups[ft];
          O = pe(f) >= 0 ? ie.firstTabbableNode : ie.firstDomTabbableNode;
        } else Ae(y) || (O = E.nextTabbableNode(f));
      }
    } else O = l("fallbackFocus");
    return O;
  }, S = function(h) {
    if (!(d(Be(h), h) >= 0)) {
      if (Re(s.clickOutsideDeactivates, h)) {
        o.deactivate({ returnFocus: s.returnFocusOnDeactivate });
        return;
      }
      Re(s.allowOutsideClick, h) || h.preventDefault();
    }
  }, k = function(h) {
    var f = Be(h), y = d(f, h) >= 0;
    if (y || f instanceof Document)
      y && (a.mostRecentlyFocusedNode = f);
    else {
      h.stopImmediatePropagation();
      var T, I = !0;
      if (a.mostRecentlyFocusedNode)
        if (pe(a.mostRecentlyFocusedNode) > 0) {
          var O = d(a.mostRecentlyFocusedNode), R = a.containerGroups[O].tabbableNodes;
          if (R.length > 0) {
            var E = R.findIndex(function(P) {
              return P === a.mostRecentlyFocusedNode;
            });
            E >= 0 && (s.isKeyForward(a.recentNavEvent) ? E + 1 < R.length && (T = R[E + 1], I = !1) : E - 1 >= 0 && (T = R[E - 1], I = !1));
          }
        } else a.containerGroups.some(function(P) {
          return P.tabbableNodes.some(function(V) {
            return pe(V) > 0;
          });
        }) || (I = !1);
      else I = !1;
      I && (T = g({
        target: a.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(a.recentNavEvent)
      })), w(T || a.mostRecentlyFocusedNode || u());
    }
    a.recentNavEvent = void 0;
  }, N = function(h) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = h;
    var y = g({
      event: h,
      isBackward: f
    });
    y && (Ae(h) && h.preventDefault(), w(y));
  }, L = function(h) {
    (s.isKeyForward(h) || s.isKeyBackward(h)) && N(h, s.isKeyBackward(h));
  }, q = function(h) {
    Sa(h) && Re(s.escapeDeactivates, h) !== !1 && (h.preventDefault(), o.deactivate());
  }, J = function(h) {
    d(Be(h), h) >= 0 || Re(s.clickOutsideDeactivates, h) || Re(s.allowOutsideClick, h) || (h.preventDefault(), h.stopImmediatePropagation());
  }, C = function() {
    if (!a.active) return Promise.resolve();
    te.activateTrap(i, o);
    var h;
    return s.delayInitialFocus ? h = new Promise(function(f) {
      a.delayInitialFocusTimer = Yt(function() {
        w(u()), f();
      });
    }) : (h = Promise.resolve(), w(u())), r.addEventListener("focusin", k, !0), r.addEventListener("mousedown", S, {
      capture: !0,
      passive: !1
    }), r.addEventListener("touchstart", S, {
      capture: !0,
      passive: !1
    }), r.addEventListener("click", J, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", L, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", q), h;
  }, _ = function(h) {
    a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var f = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new Set(), T = Kt(h), I;
    try {
      for (T.s(); !(I = T.n()).done; ) {
        var O = I.value;
        f.add(O);
        for (var R = typeof ShadowRoot < "u" && O.getRootNode() instanceof ShadowRoot, E = O; E; ) {
          f.add(E);
          var P = E.parentElement, V = [];
          P ? V = P.children : !P && R && (V = E.getRootNode().children, P = E.getRootNode().host, R = typeof ShadowRoot < "u" && P.getRootNode() instanceof ShadowRoot);
          var H = Kt(V), j;
          try {
            for (H.s(); !(j = H.n()).done; ) {
              var ft = j.value;
              y.add(ft);
            }
          } catch (ie) {
            H.e(ie);
          } finally {
            H.f();
          }
          E = P;
        }
      }
    } catch (ie) {
      T.e(ie);
    } finally {
      T.f();
    }
    f.forEach(function(ie) {
      y.delete(ie);
    }), a.adjacentElements = y;
  }, Q = function() {
    if (a.active)
      return r.removeEventListener("focusin", k, !0), r.removeEventListener("mousedown", S, !0), r.removeEventListener("touchstart", S, !0), r.removeEventListener("click", J, !0), r.removeEventListener("keydown", L, !0), r.removeEventListener("keydown", q), o;
  }, ee = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(h) {
    h.some(function(f) {
      return Array.from(f.removedNodes).some(function(y) {
        return y === a.mostRecentlyFocusedNode;
      });
    }) && w(u());
  }) : void 0, B = function() {
    ee && (ee.disconnect(), a.active && !a.paused && a.containers.map(function(h) {
      ee.observe(h, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(h) {
      if (a.active) return this;
      var f = c(h, "onActivate"), y = c(h, "onPostActivate"), T = c(h, "checkCanFocusTrap"), I = te.getActiveTrap(i), O = !1;
      if (I && !I.paused) {
        var R;
        (R = I._setSubtreeIsolation) === null || R === void 0 || R.call(I, !1), O = !0;
      }
      try {
        T || p(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = m(r), f?.();
        var E = /* @__PURE__ */ (function() {
          var V = zt(/* @__PURE__ */ Oe().m(function H() {
            return Oe().w(function(j) {
              for (; ; ) switch (j.n) {
                case 0:
                  return T && p(), j.n = 1, C();
                case 1:
                  o._setSubtreeIsolation(!0), B(), y?.();
                case 2:
                  return j.a(2);
              }
            }, H);
          }));
          return function() {
            return V.apply(this, arguments);
          };
        })();
        if (T)
          return T(a.containers.concat()).then(E, E), this;
        E();
      } catch (V) {
        if (I === te.getActiveTrap(i) && O) {
          var P;
          (P = I._setSubtreeIsolation) === null || P === void 0 || P.call(I, !0);
        }
        throw V;
      }
      return this;
    },
    deactivate: function(h) {
      if (!a.active) return this;
      var f = Gt({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, h);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), Q(), a.active = !1, a.paused = !1, B(), te.deactivateTrap(i, o);
      var y = c(f, "onDeactivate"), T = c(f, "onPostDeactivate"), I = c(f, "checkCanReturnFocus"), O = c(f, "returnFocus", "returnFocusOnDeactivate");
      y?.();
      var R = function() {
        Yt(function() {
          O && w(v(a.nodeFocusedBeforeActivation)), T?.();
        });
      };
      return O && I ? (I(v(a.nodeFocusedBeforeActivation)).then(R, R), this) : (R(), this);
    },
    pause: function(h) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, h)) : this;
    },
    unpause: function(h) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, h)) : this;
    },
    updateContainerElements: function(h) {
      return a.containers = [].concat(h).filter(Boolean).map(function(f) {
        return typeof f == "string" ? r.querySelector(f) : f;
      }), s.isolateSubtrees && _(a.containers), a.active && (p(), a.paused || o._setSubtreeIsolation(!0)), B(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: { value: function() {
      return a.manuallyPaused;
    } },
    _setPausedState: { value: function(h, f) {
      if (a.paused === h) return this;
      if (a.paused = h, h) {
        var y = c(f, "onPause"), T = c(f, "onPostPause");
        y?.(), Q(), o._setSubtreeIsolation(!1), B(), T?.();
      } else {
        var I = c(f, "onUnpause"), O = c(f, "onPostUnpause");
        I?.(), (/* @__PURE__ */ (function() {
          var R = zt(/* @__PURE__ */ Oe().m(function E() {
            return Oe().w(function(P) {
              for (; ; ) switch (P.n) {
                case 0:
                  return p(), P.n = 1, C();
                case 1:
                  o._setSubtreeIsolation(!0), B(), O?.();
                case 2:
                  return P.a(2);
              }
            }, E);
          }));
          return function() {
            return R.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(h) {
      s.isolateSubtrees && a.adjacentElements.forEach(function(f) {
        var y;
        h ? s.isolateSubtrees === "aria-hidden" ? ((f.ariaHidden === "true" || ((y = f.getAttribute("aria-hidden")) === null || y === void 0 ? void 0 : y.toLowerCase()) === "true") && a.alreadySilent.add(f), f.setAttribute("aria-hidden", "true")) : ((f.inert || f.hasAttribute("inert")) && a.alreadySilent.add(f), f.setAttribute("inert", !0)) : a.alreadySilent.has(f) || (s.isolateSubtrees === "aria-hidden" ? f.removeAttribute("aria-hidden") : f.removeAttribute("inert"));
      });
    } }
  }), o.updateContainerElements(t), o;
};
function Ca(e) {
  let t, n;
  window.addEventListener("focusin", () => {
    t = n, n = document.activeElement;
  }), e.magic("focus", (r) => {
    let i = r;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(s) {
        return i = s, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(s) {
        return ze(s);
      },
      previouslyFocused() {
        return t;
      },
      lastFocused() {
        return t;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(i) ? i : Hn(i, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(s) {
        let a = this.all();
        return a[0] && a[0].isSameNode(s);
      },
      isLast(s) {
        let a = this.all();
        return a.length && a.slice(-1)[0].isSameNode(s);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let s = this.all(), a = document.activeElement;
        if (s.indexOf(a) !== -1)
          return this.__wrapAround && s.indexOf(a) === s.length - 1 ? s[0] : s[s.indexOf(a) + 1];
      },
      getPrevious() {
        let s = this.all(), a = document.activeElement;
        if (s.indexOf(a) !== -1)
          return this.__wrapAround && s.indexOf(a) === 0 ? s.slice(-1)[0] : s[s.indexOf(a) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(s) {
        s && setTimeout(() => {
          s.hasAttribute("tabindex") || s.setAttribute("tabindex", "0"), s.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), e.directive("trap", e.skipDuringClone((r, { expression: i, modifiers: s }, { effect: a, evaluateLater: o, cleanup: c }) => {
    let d = o(i), l = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => r
    }, p = () => {
    };
    if (s.includes("noautofocus")) u.initialFocus = !1;
    else {
      let g = r.querySelector("[autofocus]");
      g && (u.initialFocus = g);
    }
    s.includes("inert") && (u.onPostActivate = () => {
      e.nextTick(() => {
        p = Xt(r);
      });
    });
    let m = Ra(r, u), w = () => {
    };
    const v = () => {
      p(), p = () => {
      }, w(), w = () => {
      }, m.deactivate({ returnFocus: !s.includes("noreturn") });
    };
    a(() => d((g) => {
      l !== g && (g && !l && (s.includes("noscroll") && (w = ka()), setTimeout(() => {
        m.activate();
      }, 15)), !g && l && v(), l = !!g);
    })), c(v);
  }, (r, { expression: i, modifiers: s }, { evaluate: a }) => {
    s.includes("inert") && a(i) && Xt(r);
  }));
}
function Xt(e) {
  let t = [];
  return Kn(e, (n) => {
    let r = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), t.push(() => r || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; t.length; ) t.pop()();
  };
}
function Kn(e, t) {
  e.isSameNode(document.body) || !e.parentNode || Array.from(e.parentNode.children).forEach((n) => {
    n.isSameNode(e) ? Kn(e.parentNode, t) : t(n);
  });
}
function ka() {
  let e = document.documentElement.style.overflow, t = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth, r = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", r && r !== "auto" ? () => {
    document.documentElement.style.overflow = e;
  } : (document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = e, document.documentElement.style.paddingRight = t;
  });
}
var Ea = Ca;
function Oa(e) {
  e.directive("intersect", e.skipDuringClone((t, { value: n, expression: r, modifiers: i }, { evaluateLater: s, cleanup: a }) => {
    let o = s(r), c = Da(i), d = {
      rootMargin: qa(i),
      threshold: c,
      root: i.includes("parent") ? t.parentElement : null
    };
    if (i.includes("dwell")) {
      Na(t, n, i, o, a, d, c);
      return;
    }
    let l = new IntersectionObserver((u) => {
      u.forEach((p) => {
        p.isIntersecting !== (n === "leave") && (o(), i.includes("once") && l.disconnect());
      });
    }, d);
    l.observe(t), a(() => {
      l.disconnect();
    });
  }));
}
function Na(e, t, n, r, i, s, a) {
  let o, c, d = !1, l = !1, u = Aa(n), p, m = () => {
    clearTimeout(o), o = void 0;
  }, w = () => {
    l = !1, !(!c || document.hidden || !Ue(c, t, a)) && (d = !0, r(), n.includes("once") && (p.disconnect(), document.removeEventListener("visibilitychange", N)));
  }, v = () => {
    p && p.disconnect(), p = new IntersectionObserver(k, s), p.observe(e);
  }, g = () => {
    if (o = void 0, document.hidden) return;
    let L = p.takeRecords();
    if (L.some((q) => !Ue(q, t, a))) {
      k(L);
      return;
    }
    l = !0, c = void 0, v();
  }, S = () => {
    o !== void 0 || d || document.hidden || !c || Ue(c, t, a) && (o = setTimeout(g, u));
  }, k = (L) => {
    L.forEach((q) => {
      if (c = q, !Ue(q, t, a)) {
        m(), d = !1, l = !1;
        return;
      }
      if (l) {
        w();
        return;
      }
      S();
    });
  }, N = () => {
    if (document.hidden) {
      m(), c = void 0, d = !1, l = !1, p.disconnect();
      return;
    }
    v();
  };
  v(), document.addEventListener("visibilitychange", N), i(() => {
    m(), p.disconnect(), document.removeEventListener("visibilitychange", N);
  });
}
function Ue(e, t, n) {
  let r = n === 0 ? e.isIntersecting : e.isIntersecting && e.intersectionRatio >= n;
  return t === "leave" ? !r : r;
}
function Aa(e) {
  let t = (e[e.indexOf("dwell") + 1] || "").match(/^([0-9]+)(ms)?$/);
  return t ? Number(t[1]) : 250;
}
function Da(e) {
  if (e.includes("full")) return 0.99;
  if (e.includes("half")) return 0.5;
  if (!e.includes("threshold")) return 0;
  let t = e[e.indexOf("threshold") + 1];
  return t === "100" ? 1 : t === "0" ? 0 : +`.${t}`;
}
function Pa(e) {
  let t = e.match(/^(-?[0-9]+)(px|%)?$/);
  return t ? t[1] + (t[2] || "px") : void 0;
}
function qa(e) {
  const t = "margin", n = "0px 0px 0px 0px", r = e.indexOf(t);
  if (r === -1) return n;
  let i = [];
  for (let s = 1; s < 5; s++) i.push(Pa(e[r + s] || ""));
  return i = i.filter((s) => s !== void 0), i.length ? i.join(" ").trim() : n;
}
var La = Oa;
function kt(e, t, n) {
  Gn();
  let r = Wn(n), i = typeof t == "string" ? $a(t) : t;
  return window.Alpine && window.Alpine.closestDataStack && !e._x_dataStack && (i._x_dataStack = window.Alpine.closestDataStack(e), i._x_dataStack && window.Alpine.cloneNode(e, i)), r.patch(e, i), e;
}
function _a(e, t, n, r = {}) {
  Gn();
  let i = Wn(r), s = e.parentNode, a = new Pe(e, t), o = typeof n == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", n), u;
  })() : n, c = document.createComment("[morph-start]"), d = document.createComment("[morph-end]");
  o.insertBefore(c, o.firstChild), o.appendChild(d);
  let l = new Pe(c, d);
  window.Alpine && window.Alpine.closestDataStack && (o._x_dataStack = window.Alpine.closestDataStack(s), o._x_dataStack && window.Alpine.cloneNode(s, o)), i.patchChildren(a, l);
}
function Wn(e = {}) {
  let t = (i) => i.getAttribute("key"), n = () => {
  }, r = {
    key: e.key || t,
    lookahead: e.lookahead || !1,
    updating: e.updating || n,
    updated: e.updated || n,
    removing: e.removing || n,
    removed: e.removed || n,
    adding: e.adding || n,
    added: e.added || n
  };
  return r.patch = function(i, s) {
    if (r.differentElementNamesTypesOrKeys(i, s)) return r.swapElements(i, s);
    let a = !1, o = !1, c = (d) => r.skipUntilCondition = d;
    if (!Fa(r.updating, () => o = !0, c, i, s, () => a = !0)) {
      if (i.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(i, s), i._x_teleport && s._x_teleport && r.patch(i._x_teleport, s._x_teleport)), Ja(s)) {
        r.patchNodeValue(i, s), r.updated(i, s);
        return;
      }
      a || r.patchAttributes(i, s), r.updated(i, s), o || r.patchChildren(i, s);
    }
  }, r.differentElementNamesTypesOrKeys = function(i, s) {
    return i.nodeType != s.nodeType || i.nodeName != s.nodeName || r.getKey(i) != r.getKey(s);
  }, r.swapElements = function(i, s) {
    if (Ce(r.removing, i)) return;
    let a = s.cloneNode(!0);
    Ce(r.adding, a) || (i.replaceWith(a), r.removed(i), r.added(a));
  }, r.patchNodeValue = function(i, s) {
    let a = s.nodeValue;
    i.nodeValue !== a && (i.nodeValue = a);
  }, r.patchAttributes = function(i, s) {
    if (i._x_transitioning || i._x_isShown && !s._x_isShown || !i._x_isShown && s._x_isShown) return;
    let a = Array.from(i.attributes), o = Array.from(s.attributes);
    for (let c = a.length - 1; c >= 0; c--) {
      let d = a[c].name;
      s.hasAttribute(d) || (d === "open" && i.nodeName === "DIALOG" && i.open ? i.close() : i.removeAttribute(d));
    }
    for (let c = o.length - 1; c >= 0; c--) {
      let d = o[c].name, l = o[c].value;
      i.getAttribute(d) !== l && i.setAttribute(d, l);
    }
  }, r.patchChildren = function(i, s) {
    let a = r.keyToMap(i.children), o = {}, c = Zt(s), d = Zt(i);
    for (; c; ) {
      Ma(c, d);
      let u = r.getKey(c), p = r.getKey(d);
      if (r.skipUntilCondition) {
        let g = !d || r.skipUntilCondition(d), S = !c || r.skipUntilCondition(c);
        if (g && S) r.skipUntilCondition = null;
        else {
          g || (d = d && U(i, d)), S || (c = c && U(s, c));
          continue;
        }
      }
      if (!d)
        if (u && o[u]) {
          let g = o[u];
          i.appendChild(g), d = g, p = r.getKey(d);
        } else {
          if (!Ce(r.adding, c)) {
            let g = c.cloneNode(!0);
            i.appendChild(g), r.added(g);
          }
          c = U(s, c);
          continue;
        }
      let m = (g) => g && g.nodeType === 8 && g.textContent === "[if BLOCK]><![endif]", w = (g) => g && g.nodeType === 8 && g.textContent === "[if ENDBLOCK]><![endif]";
      if (m(c) && m(d)) {
        let g = 0, S = d;
        for (; d; ) {
          let C = U(i, d);
          if (m(C)) g++;
          else if (w(C) && g > 0) g--;
          else if (w(C) && g === 0) {
            d = C;
            break;
          }
          d = C;
        }
        let k = d;
        g = 0;
        let N = c;
        for (; c; ) {
          let C = U(s, c);
          if (m(C)) g++;
          else if (w(C) && g > 0) g--;
          else if (w(C) && g === 0) {
            c = C;
            break;
          }
          c = C;
        }
        let L = c, q = new Pe(S, k), J = new Pe(N, L);
        r.patchChildren(q, J);
        continue;
      }
      if (d.nodeType === 1 && r.lookahead && !d.isEqualNode(c)) {
        let g = U(s, c), S = !1;
        for (; !S && g; )
          g.nodeType === 1 && d.isEqualNode(g) && (S = !0, d = r.addNodeBefore(i, c, d), p = r.getKey(d)), g = U(s, g);
      }
      if (u !== p) {
        if (!u && p) {
          o[p] = d, d = r.addNodeBefore(i, c, d), o[p].remove(), d = U(i, d), c = U(s, c);
          continue;
        }
        if (u && !p && a[u] && (d.replaceWith(a[u]), d = a[u], p = r.getKey(d)), u && p) {
          let g = a[u];
          if (g)
            o[p] = d, d.replaceWith(g), d = g, p = r.getKey(d);
          else {
            o[p] = d, d = r.addNodeBefore(i, c, d), o[p].remove(), d = U(i, d), c = U(s, c);
            continue;
          }
        }
      }
      let v = d && U(i, d);
      r.patch(d, c), d._x_lastRenderedEl && (v = U(i, d._x_lastRenderedEl)), c = c && U(s, c), d = v;
    }
    let l = [];
    for (; d; )
      Ce(r.removing, d) || l.push(d), d = U(i, d);
    for (; l.length; ) {
      let u = l.shift();
      u.remove(), r.removed(u);
    }
  }, r.getKey = function(i) {
    return i && i.nodeType === 1 && r.key(i);
  }, r.keyToMap = function(i) {
    let s = {};
    for (let a of i) {
      let o = r.getKey(a);
      o && (s[o] = a);
    }
    return s;
  }, r.addNodeBefore = function(i, s, a) {
    if (!Ce(r.adding, s)) {
      let o = s.cloneNode(!0);
      return i.insertBefore(o, a), r.added(o), o;
    }
    return s;
  }, r;
}
kt.step = () => {
};
kt.log = () => {
};
function Ce(e, ...t) {
  let n = !1;
  return e(...t, () => n = !0), n;
}
function Fa(e, t, n, ...r) {
  let i = !1;
  return e(...r, () => i = !0, t, n), i;
}
var Qt = !1;
function $a(e) {
  const t = document.createElement("template");
  return t.innerHTML = e, t.content.firstElementChild;
}
function Ja(e) {
  return e.nodeType === 3 || e.nodeType === 8;
}
var Pe = class {
  constructor(e, t) {
    this.startComment = e, this.endComment = t;
  }
  get children() {
    let e = [], t = this.startComment.nextSibling;
    for (; t && t !== this.endComment; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  appendChild(e) {
    this.endComment.before(e);
  }
  get firstChild() {
    let e = this.startComment.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  nextNode(e) {
    let t = e.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  insertBefore(e, t) {
    return t.before(e), e;
  }
};
function Zt(e) {
  return e.firstChild;
}
function U(e, t) {
  let n;
  return e instanceof Pe ? n = e.nextNode(t) : n = t.nextSibling, n;
}
function Gn() {
  if (Qt) return;
  Qt = !0;
  let e = Element.prototype.setAttribute, t = document.createElement("div");
  Element.prototype.setAttribute = function(r, i) {
    if (!r.includes("@")) return e.call(this, r, i);
    let s = i.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    t.innerHTML = `<span ${r}="${s}"></span>`;
    let a = t.firstElementChild.getAttributeNode(r);
    t.firstElementChild.removeAttributeNode(a), this.setAttributeNode(a);
  };
}
function Ma(e, t) {
  let n = t && t._x_bindings && t._x_bindings.id;
  n && e.setAttribute && (e.setAttribute("id", n), e.id = n);
}
function ja(e) {
  e.morph = kt, e.morphBetween = _a;
}
var Ba = ja, Ua = (e, t) => {
  let n;
  const r = /* @__PURE__ */ new Set();
  return function(i, s) {
    n && clearTimeout(n), i.forEach(({ target: a }) => r.add(a)), n = setTimeout(() => {
      e(r, s), n = null;
    }, t);
  };
}, Va = (e) => {
  e.forEach((t) => Ha(t)), e.clear();
}, Ha = (e) => {
  const t = (a) => e.setAttribute("sizes", (a | 0) + "px");
  let n = 0, r = 0, i = e;
  for (; n < 100 && i; )
    n = i.offsetWidth, r = i.offsetHeight, i = i.parentNode;
  if (getComputedStyle(e).objectFit !== "cover") return t(n);
  const s = Number(e.getAttribute("width")) / Number(e.getAttribute("height"));
  if (!s || n / r >= s + 0.1) return t(n);
  t(r * s);
}, de = new ResizeObserver(Ua(Va, 800)), en = (e, t, n) => {
  if (t) return Ka(e);
  if (n) return za(e, n);
  throw new TypeError("Invalid options");
}, za = (e, t) => (e = new URL(e, document.baseURI).href, e.includes("localhost") ? () => e : (n) => (t + e).replace("{width}", String(n))), Ka = (e) => {
  if (e.includes("{width}")) return (t) => e.replaceAll("{width}", String(t));
  if (nn.test(e)) {
    const t = e.replace(nn, "_{width}x$1");
    return (n) => t.replaceAll("{width}", String(n));
  }
  return (t) => {
    const n = new URL(e, document.baseURI);
    return n.searchParams.set("width", String(t)), n.href;
  };
}, Wa = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], tn = (e, t = 1 / 0) => Wa.filter((n) => n <= t).map((n) => `${e(n)} ${n}w`).join(","), nn = /_\d+x(\.jpg|\.png)/;
function Ga(e) {
  const { autoSize: t = !0, shopify: n = !1, maxSize: r = 0, cloudURL: i = "" } = Ya(e) ?? {};
  return (s) => {
    s.directive("rias", (o, { expression: c }, { effect: d, evaluateLater: l, cleanup: u }) => {
      if (!(o instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => de.unobserve(o)), !c) return t && de.observe(o);
      const p = l(c);
      d(() => {
        p((m) => {
          if (!m || typeof m != "string") return;
          const w = en(m, n, i), v = r || Number(o.dataset.maxSize) || 1 / 0, g = w(Math.min(v, 360)), S = tn(w, v);
          s.mutateDom(() => {
            o.src = g, o.srcset = S, o.loading = o.loading == "eager" ? "eager" : "lazy", (t || o.dataset.sizes == "auto") && de.observe(o);
          });
        });
      });
    });
    const a = {
      srcset(o) {
        return tn(en(o, n, i), r || 1 / 0);
      },
      observe: de.observe.bind(de),
      unobserve: de.unobserve.bind(de)
    };
    s.magic("rias", () => a);
  };
}
var Ya = (e) => {
  if (typeof e == "string") return { cloudURL: `https://res.cloudinary.com/${e}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof e == "object") return {
    ...e,
    cloudURL: e.key ? `https://res.cloudinary.com/${e.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, Xa = (e) => {
  e.addRootSelector(() => `[${e.prefixed("data-async")}]`);
  const t = "data-async", n = e.prefixed("ignore"), r = {}, i = /* @__PURE__ */ new WeakSet(), s = (a, { expression: o }, { evaluateLater: c, evaluate: d, cleanup: l }) => {
    i.has(a) || (i.add(a), c(o)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const p = e.reactive(u), m = e.addScopeToNode(a, p);
      p.init && d(p.init), l(() => {
        p.destroy && d(p.destroy), m();
      }), delete a._x_ignore, a.removeAttribute(n), e.initTree(a);
    }, { scope: r }));
  };
  s.inline = (a, { expression: o }) => {
    i.has(a) || (a._x_ignore = !0, a.setAttribute(n, ""));
  }, e.directive(t, s).before("ignore"), e.asyncData = (a, o) => {
    r[a] = async (...c) => {
      const [d, l] = o.split("?");
      try {
        const u = await import(d);
        if (l && l in u) return u[l](...c);
        if (a in u) return u[a](...c);
        if (u.default && typeof u.default == "function") return u.default(...c);
        if (typeof u == "function") return u(...c);
        throw new Error(`Async Data: Module ${o} does not export a function named ${a}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", a, o), console.error(u), {};
      }
    };
  };
}, Qa = (e) => {
  e.directive("clickable", (r, { expression: i }, { cleanup: s }) => {
    const a = r.querySelector(i || "a, button");
    if (!a) return console.warn(`x-clickable: No target found for selector ${i || "a, button"}`);
    const o = function(c) {
      const d = c.target;
      !(d instanceof HTMLElement) || t(d, r) !== r || n(a, c.constructor, c);
    };
    s(e.bind(r, {
      "@click": o,
      "@auxclick": o
    }));
  });
  const t = (r, i) => e.findClosest(r, (s) => s.matches("a, button, input, select") || s === i), n = (r, i = MouseEvent, s) => r.dispatchEvent(new i("click", s));
}, Za = class {
  el;
  details;
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(e, t, n) {
    this.el = e, this.details = n, this.backdrop = t.backdrop, this.keyboard = t.keyboard;
  }
  withDetails(e) {
    return e && (this.details = e), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, es = class extends EventTarget {
  Alpine;
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(e) {
    super(), this.Alpine = e;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(e, t) {
    if (e === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const n = this.availableDialogs.get(e) ?? null;
    return n ? (this.active = n, n.withDetails(t).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: n })), this) : (console.error(`Modal with id "${e}" does not exist`), this);
  }
  close(e) {
    const t = e ?? this.active;
    return t ? (t.close().then((n) => n === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: t })), this) : (console.log(e, t, "there is no active"), this);
  }
  setOptions(e) {
    return this.active && Object.assign(this.active, e), this;
  }
  isRegistered(e) {
    return this.availableDialogs.has(e);
  }
  unregister(e) {
    return this.availableDialogs.delete(e), this.active?.id === e && (this.active = null), this;
  }
  create(e, t, n) {
    const r = this.Alpine.reactive(new Za(e, t, n));
    return this.availableDialogs.set(r.id, r), r;
  }
}, ts = (e) => {
  const t = new es(e);
  e.addRootSelector(() => `[${e.prefixed("dialog")}]`), e.directive("dialog", (n, { expression: r }, { evaluate: i, cleanup: s }) => {
    if (!(n instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", n);
    const a = n.id;
    console.assert(!!a, "x-dialog element must have an ID: %o", n);
    const { backdrop: o = !0, keyboard: c = !0 } = r ? i(r) : {}, d = t.create(n, {
      backdrop: o,
      keyboard: c
    });
    s(e.addScopeToNode(n, { $dialog: d })), s(t.unregister.bind(t, a)), s(e.bind(n, {
      "@click.self"() {
        d.backdrop && t.close(d);
      },
      "@cancel.prevent.stop"() {
        d.keyboard && t.close(d);
      },
      "@dialog-closed.self"(l) {
        l.detail === d && d === t.active && (t.active = null, t.dispatchEvent(new CustomEvent("dialog-closed", { detail: d })));
      },
      "@keydown.escape.prevent.stop"() {
        d.keyboard && t.close(d);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": d.closing,
          "dialog-in backdrop:animate-fade-in": d.opening
        };
      }
    }));
  }), e.magic("dialogs", () => t), e.$dialogs = t;
}, Ke = /* @__PURE__ */ (function(e) {
  return e.Up = "up", e.Down = "down", e;
})(Ke || {}), ns = (e) => {
  const t = /* @__PURE__ */ new Set(), n = e.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Ke.Up,
    onScroll: (i) => (t.add(i), () => t.delete(i))
  });
  let r;
  n.onScroll((i) => {
    const s = i.current > i.previous ? Ke.Down : Ke.Up;
    s !== n.direction ? r ??= setTimeout(() => n.direction = s, 200) : (clearTimeout(r), r = void 0);
  }), window.addEventListener("scroll", () => {
    n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, t.forEach((i) => i(n));
  }, { passive: !0 }), e.$scroll = n, e.magic("scroll", () => n);
}, $ = /* @__PURE__ */ Symbol("$slider"), Yn = (e) => $ in e, rs = {
  ":disabled"() {
    return this[$].isLast;
  },
  "x-on:click"() {
    this[$].next(this.$el);
  }
}, is = {
  ":disabled"() {
    return this[$].isFirst;
  },
  "x-on:click"() {
    this[$].prev(this.$el);
  }
}, as = (e) => ({
  ":disabled"() {
    return this[$].focusedIndex === e;
  },
  "x-on:click"() {
    this[$].scrollTo(e);
  }
}), ss = {
  "x-on:mouseenter"() {
    this[$].pause();
  },
  "x-on:mouseleave"() {
    this[$].unpause();
  },
  "x-on:focusin"() {
    this[$].pause();
  },
  "x-on:focusout"() {
    this[$].unpause();
  }
}, os = { ":style"() {
  const e = this[$].focusedSize;
  return {
    maxHeight: e ? `${e}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, cs = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const e = this[$];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const e = this[$];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[$].onLoad(this.$el);
  },
  "x-on:load"() {
    this[$].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const e = this[$], t = this.index, n = e.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": t > n,
      "slide-previous": t < n,
      "slide-current": t === n,
      "slide-visible": this.visible
    };
  }
}, ds = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, ls = (e, t, n, { Alpine: r, cleanup: i }) => {
  const s = r.$data(t);
  if (!Yn(s)) {
    console.error(`Element with ${n.original} needs to be inside an x-slider element`, t);
    return;
  }
  const a = s[$];
  if (a.components.set(e, t), e === "gallery") {
    const o = new AbortController();
    t.addEventListener("scroll", a.updateEdges.bind(a), {
      passive: !0,
      signal: o.signal
    }), i(() => o.abort()), a.updateEdges();
  }
}, ue = (e) => Array.from(e.children).flatMap((t) => getComputedStyle(t).display === "contents" ? ue(t) : t).filter((t) => t.nodeName !== "TEMPLATE" && getComputedStyle(t).display !== "none"), us = (e, t) => {
  let n = 0, r = Number.POSITIVE_INFINITY;
  for (let i = 0; i < e.length; i++) {
    const s = Math.abs(e[i] - t);
    if (s >= r) return n;
    r = s, n = i;
  }
  return n;
}, hs = (e, t, n, r = 1) => {
  const i = t - n;
  return {
    atStart: e <= r,
    atEnd: e >= i - r
  };
}, fs = (e) => e instanceof HTMLImageElement, ps = (e, { expression: t }, { evaluate: n, cleanup: r, Alpine: i }) => {
  const s = [];
  r(() => s.forEach((c) => c()));
  const a = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, t ? n(t) : {}), o = i.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!a.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (a.autoScroll) {
        const c = new ms(a.autoScroll).onTick((d) => {
          this.autoScrollPercentage = d;
        }).onFinish(() => {
          if (this.touched) return c.abort();
          if (this.paused) return;
          const d = this.components.get("gallery");
          d && this.scrollTo(Dr(this.focusedIndex + 1, ue(d).length));
        });
        s.push(() => c.abort());
      }
    },
    onLoad(c) {
      if (this.initialized || fs(c) && !c.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const d = this.components.get("gallery");
      d && (d.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(c, d = !0) {
      if (!this.initialized) return;
      const l = this.components.get("gallery");
      if (d && (!l || a.animated)) {
        this.focusedIndex = this.indexOfItem(c) ?? 0, this.focusedSize = c.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = ue(c), l = parseFloat(getComputedStyle(c).scrollPaddingLeft) || 0, u = d.map((m) => ve(HTMLElement, m)?.offsetLeft ?? 0), p = us(u, c.scrollLeft + l);
      this.focusedIndex = p, this.focusedSize = ve(HTMLElement, d[p])?.clientHeight ?? e.clientHeight;
    },
    itemAtIndex(c) {
      const d = this.components.get("gallery");
      if (!d) return;
      const l = ue(d);
      let u = l[Or(c, l.length - 1)];
      if (u !== void 0) {
        for (let p = 0; p < a.scrollToDepth; p++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(c + 1) : u;
      }
    },
    indexOfItem(c) {
      const d = this.components.get("gallery");
      if (!d) return;
      const l = ue(d);
      for (let u = 0; u < l.length; u++) if (l[u].contains(c)) return u;
    },
    async scrollTo(c, d = 0, l = !1, u = !1) {
      const p = this.components.get("gallery");
      if (!p) return;
      const m = c instanceof Element ? c : this.itemAtIndex(c);
      if (!m) return;
      l && (this.touched = !0);
      const w = typeof c == "number" ? c : this.indexOfItem(m) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Ar()), u || a.animated ? this.focusedIndex = w : this.focusedIndex += Math.sign(w - this.focusedIndex), a.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), a.intoView ? m.scrollIntoView({
        behavior: "smooth",
        block: a.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (p.style.scrollBehavior = "auto"), p.scrollLeft = c === 0 ? 0 : (ve(HTMLElement, m)?.offsetLeft ?? 0) - d, u && (p.style.scrollBehavior = null)));
      const v = this.components.get("thumbnails");
      if (!v) return;
      const g = ve(HTMLElement, v.children[w]);
      g && v.scrollTo({
        top: g.offsetTop - (v.clientHeight - g.clientHeight) / 2,
        left: g.offsetLeft - (v.clientWidth - g.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const c = this.components.get("gallery");
      if (!c || a.animated) return;
      const { atStart: d, atEnd: l } = hs(c.scrollLeft, c.scrollWidth, c.clientWidth);
      this.atStart = d, this.atEnd = l;
    },
    get isFirst() {
      return a.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const c = this.components.get("gallery");
      return c ? a.animated ? this.focusedIndex === ue(c).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const c = this.components.get("gallery");
      return c ? ue(c).length : 0;
    },
    next(c) {
      const d = this.getStepInfo(c);
      this.scrollTo(Math.max(0, this.focusedIndex + d), 10, !0);
    },
    prev(c) {
      const d = this.getStepInfo(c);
      this.scrollTo(Math.max(0, this.focusedIndex - d), 10, !0);
    },
    getStepInfo(c) {
      const d = getComputedStyle(c);
      let l = parseInt(d.getPropertyValue("--perpage") || "1");
      const u = d.getPropertyValue("--arrow-step").trim(), p = this.components.get("gallery");
      if (p && u === "view") {
        const m = ve(HTMLElement, this.itemAtIndex(0)), w = ve(HTMLElement, this.itemAtIndex(1)), v = m && w && m !== w ? Math.abs(w.offsetLeft - m.offsetLeft) : 0;
        v > 0 && (l = Math.max(1, Math.floor(p.clientWidth / v)));
      }
      return l;
    }
  });
  i.addScopeToNode(e, { [$]: o }), a.autoInitialize && o.init();
}, ms = class Xn extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(t) {
    super(), this.duration = t, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (t) => {
    if (this.controller.signal.aborted) return;
    const n = t - this.lastTimestep;
    this.lastTimestep = t, this.currentTime += n, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(t) {
    return this.addEventListener("tick", () => t(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(t) {
    return this.addEventListener("just-finished", t, { signal: this.controller.signal }), this;
  }
  static fromSeconds(t) {
    return new Xn(t * 1e3);
  }
}, gs = (e) => {
  e.addRootSelector(() => `[${e.prefixed("slider")}]`), e.directive("slider", (t, n, r) => {
    if (!n.value || n.value === "root") return ps(t, n, r);
    (n.value === "gallery" || n.value === "thumbnails") && ls(n.value, t, n, r);
  }), e.magic("slider", (t) => {
    const n = e.$data(t);
    if (Yn(n)) return n[$];
  }), e.bind("$sliderDynamicHeight", os), e.bind("$sliderItem", cs), e.bind("$sliderNext", rs), e.bind("$sliderPrev", is), e.bind("$sliderGoTo", as), e.bind("$sliderPause", ss), e.bind("$sliderUnfocusHidden", ds);
}, rn = (e, t, n = t) => {
  const { scrollPaddingTop: r, scrollPaddingBottom: i } = window.getComputedStyle(e);
  return {
    top: an(r, t),
    bottom: an(i, n)
  };
}, an = (e, t) => e !== "auto" ? parseInt(e) : t, ws = 100, ys = (e) => {
  e.addRootSelector(() => `[${e.prefixed("smartstick")}]`), e.directive("smartstick", (t, n, { cleanup: r }) => {
    let i = rn(t, ws);
    const s = e.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + i.top}px`;
      }
    });
    let a = 0, o = window.scrollY;
    const c = () => {
      const w = window.scrollY, v = w - o;
      s.top = Math.min(a, Math.max(0, s.top + v)), o = w;
    }, d = () => {
      i = rn(t, i.top, i.bottom), a = Math.max(0, t.clientHeight - window.innerHeight + i.top + i.bottom);
    }, l = new ResizeObserver(d);
    l.observe(t), window.addEventListener("resize", d);
    const u = window.matchMedia("(min-width: 1024px)"), p = (w) => window[w.matches ? "addEventListener" : "removeEventListener"]("scroll", c, { passive: !0 });
    u.addEventListener("change", p), p(u);
    const m = e.effect(() => t.style.top = s.topString);
    r(() => {
      e.release(m), l.disconnect(), u.removeEventListener("change", p), window.removeEventListener("resize", d), window.removeEventListener("scroll", c);
    });
  });
}, Et = (e, t, n) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (i) => {
    i.addRootSelector(() => `[${i.prefixed(e)}]`);
    const s = (a) => {
      const o = i.findClosest(a, r.has.bind(r));
      if (!o) return console.error(`Could not find root for ${e} component`, a);
      if (o instanceof HTMLElement) return r.get(o);
    };
    i.magic(e, (a) => s(a)), i.directive(e, (a, o, c) => {
      if (!o.value) return r.set(a, t(a, o, c));
      const d = s(a);
      if (!d) return vs(e, a);
      (n?.[o.value] || bs(e))(d, a, o, c);
    });
  };
}, bs = (e) => (t, n, r) => {
  console.error(`Alpine ${e}: Invalid directive value`, n, r.original);
}, vs = (e, t) => console.error(`Could not find root for ${e} component`, t), We = /* @__PURE__ */ new WeakMap(), Ss = (e, t) => {
  const n = t.findClosest(e, We.has.bind(We));
  if (n instanceof HTMLElement) return We.get(n);
}, Is = (e, t, { Alpine: n, effect: r }) => {
  const i = n.reactive({
    active: null,
    id: 0,
    addAccordion(s) {
      const a = this.id++, o = n.reactive({ active: s });
      return r(() => {
        o.active ? this.active = a : this.active === a && (this.active = null);
      }), r(() => {
        this.active === a ? o.active = !0 : o.active = !1;
      }), o;
    }
  });
  return We.set(e, i), i;
}, Ts = (e) => {
  e.addRootSelector(() => `[${e.prefixed("accordion-group")}]`), e.directive("accordion-group", Is);
}, xs = (e, { modifiers: [t = "closed"] }, { Alpine: n }) => Ss(e, n)?.addAccordion(t === "open") ?? n.reactive({ active: t === "open" }), Rs = {
  open: !0,
  close: !1,
  toggle: null
}, Cs = (e, t, { modifiers: [n = "toggle"] }, { Alpine: r }) => {
  r.bind(t, {
    "x-on:click": () => {
      e.active = Rs[n] ?? !e.active;
    },
    ":aria-expanded": () => e.active
  });
}, ks = (e, t, n, { Alpine: r }) => {
  r.bind(t, { "x-show": () => e.active });
}, Es = {
  control: Cs,
  container: ks
}, Os = Et("accordion", xs, Es), Ns = (e) => {
  Ts(e), Os(e);
}, sn = new ResizeObserver((e) => {
  for (const t of e) {
    const n = t.target;
    n instanceof HTMLElement && As(n);
  }
}), As = async (e) => {
  await _e.nextTick(), e.scrollLeft = (e.scrollWidth - e.clientWidth) / 2, e.scrollTop = (e.scrollHeight - e.clientHeight) / 2;
}, on = Array.prototype.forEach, Ds = (e) => e.directive("dragscroll", (t, { modifiers: n }, { cleanup: r }) => {
  const i = n.includes("center");
  r(Ps(t)), t.classList.add("overscroll-contain", "cursor-grab"), i && (on.call(t.children, (s) => sn.observe(s)), r(() => on.call(t.children, (s) => sn.unobserve(s))));
}), ke = (e) => {
  e.preventDefault(), e.stopPropagation();
}, cn = [
  "pointerup",
  "mouseup",
  "touchend"
], Ps = (e) => {
  const t = (i) => {
    ke(i), e.scrollLeft -= i.movementX, e.scrollTop -= i.movementY;
  }, n = async (i) => {
    ke(i), document.removeEventListener("pointermove", t, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), e.classList.add("cursor-grab"), await _e.nextTick(), document.removeEventListener("click", ke, !0), cn.forEach((s) => document.removeEventListener(s, n, { capture: !0 }));
  }, r = (i) => {
    qs(i) || i.button !== 2 && (ke(i), e.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", t, { capture: !0 }), cn.forEach((s) => document.addEventListener(s, n, { capture: !0 })), document.addEventListener("click", ke, { capture: !0 }));
  };
  return e.addEventListener("pointerdown", r), () => e.removeEventListener("pointerdown", r);
}, qs = (e) => e instanceof TouchEvent || e instanceof PointerEvent && e.pointerType === "touch", Ls = (e, t, { Alpine: n }) => {
  const r = n.reactive({
    root: e,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(e, { "x-id": () => ["x-panel"] }), r;
}, _s = Et("panel", Ls, {
  summary: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      ":aria-expanded": () => e.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      "x-show": () => e.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Fs = Et("tabs", (e, t, { Alpine: n, evaluate: r }) => n.reactive({
  activeTab: 0,
  isSelected(i) {
    return this.tabs[this.activeTab] === i;
  },
  tabs: [],
  panels: [],
  $focus: r("$focus")
}), {
  list: (e, t, n, { Alpine: r }) => {
    const i = () => e.$focus.wrap().next(), s = () => e.$focus.wrap().previous();
    r.bind(t, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": s,
      "@keydown.arrow-right.stop.prevent": i,
      "@keydown.arrow-up.stop.prevent": s,
      "@keydown.arrow-down.stop.prevent": i
    });
  },
  tab: (e, t, n, { Alpine: r }) => {
    const i = e.tabs.push(t) - 1, s = () => e.activeTab = i;
    r.bind(t, {
      ":tabindex": () => +(i === e.activeTab) - 1,
      ":aria-selected": () => i === e.activeTab,
      "@click": s,
      "@keydown.space.stop.prevent": s,
      "@keydown.enter.stop.prevent": s
    });
  },
  panel: (e, t, n, { Alpine: r }) => {
    const i = e.panels.push(t) - 1;
    r.bind(t, {
      ":tab-index": () => i !== e.activeTab ? -1 : 0,
      ":aria-hidden": () => i !== e.activeTab,
      ":class"() {
        if (i === e.activeTab) return "panel-current";
        if (i > e.activeTab) return "panel-next";
        if (i < e.activeTab) return "panel-previous";
      }
    });
  }
}), qe;
(function(e) {
  e[e.None = 0] = "None", e[e.Left = 1] = "Left", e[e.Right = 2] = "Right", e[e.Up = 4] = "Up", e[e.Down = 8] = "Down";
})(qe || (qe = {}));
var Le = /* @__PURE__ */ new WeakMap(), $s = Le.has.bind(Le), Js = (e) => e.directive("swipe", (t, n, { cleanup: r }) => {
  Le.set(t, { dispatch: (i) => {
    const s = Object.entries(qe).filter(([, a]) => typeof a == "number" && a && (i & a) === a).map(([a]) => a.toLowerCase());
    t.dispatchEvent(new CustomEvent("swipe", { detail: s.join("-") })), t.dispatchEvent(new CustomEvent(`swipe${s.join("")}`, { detail: s.join("-") }));
  } }), t.addEventListener("touchstart", dn), r(() => t.removeEventListener("touchstart", dn));
}), dn = (e) => {
  const t = Le.get(e.currentTarget);
  if (!t) return;
  const { clientX: n, clientY: r } = e.touches[0];
  t.start ??= {
    x: n,
    y: r
  }, document.addEventListener("touchend", Ms, { once: !0 });
}, Ms = (e) => {
  const t = e.target;
  if (!t) return;
  const n = Le.get(Qn(t, $s));
  if (!n?.start) return;
  const { clientX: r, clientY: i } = e.changedTouches[0], s = js(n.start, {
    x: r,
    y: i
  });
  s !== qe.None && (n.dispatch(s), delete n.start);
}, Qn = (e, t) => t(e) ? e : e.parentElement ? Qn(e.parentElement, t) : null, js = (e, t) => {
  const n = [t.x - e.x, t.y - e.y];
  if (n.every((a) => Math.abs(a) < 50)) return qe.None;
  const r = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [i, s] = n.map((a) => a / r);
  return ln(i) | ln(s) << 2;
}, ln = (e) => e > 0.5 ? 2 : e < -0.5 ? 1 : 0, Bs = (e) => {
  e.magic("screen", () => (t) => {
    const n = typeof t == "number" ? t : Us[t] ?? Number(t);
    return n ? Vs(n, e).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(t)})`), !1);
  });
}, Us = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, Zn = {}, Vs = (e, t) => Zn[e] ?? Hs(e, t), Hs = (e, t) => {
  const n = window.matchMedia(`(min-width: ${e}px)`), r = t.reactive({ value: n.matches });
  return Zn[e] = r, n.addEventListener("change", (i) => {
    r.value = i.matches;
  }), r;
}, zs = (e) => e.plugin([Bs]), Ks = (e) => e.plugin([
  Ns,
  Ds,
  _s,
  Js,
  Fs,
  zs
]), Ws = (e) => {
  e.magic("abortSignal", (t, { cleanup: n }) => {
    const r = new AbortController();
    return n(() => r.abort("Alpine Component has been Removed")), r.signal;
  });
}, Gs = (e) => {
  e.magic("dataset", (t) => t.dataset), e.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : Sr);
}, Ys = (e) => {
  e.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, Xs = (e) => {
  e.directive("inert-trap", (t, { expression: n, modifiers: r }, { evaluateLater: i, effect: s }) => {
    const a = r.includes("retain"), o = r.includes("noscroll"), c = r.includes("return"), d = i(n), l = [];
    let u = null;
    s(() => {
      d((p) => {
        if (p) {
          u = document.activeElement;
          for (const m of Qs(t, ...document.querySelectorAll("[role=alertdialog]"), a ? u?.closest("[data-retain-focus-from]") ?? u : null))
            m.setAttribute("inert", "inert"), l.push(m);
          o && (document.documentElement.style.setProperty("overflow", "hidden"), document.body.style.setProperty("overflow", "hidden"));
        } else {
          for (const m of l) m.removeAttribute("inert");
          l.length = 0, o && (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("overflow")), c && u && (u.focus(), u = null);
        }
      });
    });
  });
};
function Qs(...e) {
  return e = e.filter((t) => t !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (t) => {
    if (!(t instanceof HTMLElement) || t.matches("[inert] > *") || e.includes(t)) return NodeFilter.FILTER_REJECT;
    for (const n of e) if (t.contains(n)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
var Zs = (e) => {
  e.directive("highlight-scroll", (t, { expression: n }, { cleanup: r }) => {
    const i = n.trim();
    if (!i) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const s = t.firstChild;
    if (!s || !(s instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const a = (s.textContent?.trim().split("") ?? []).map((d) => {
      const l = document.createElement("span");
      return l.textContent = d, l.classList.add(i), l;
    });
    s.replaceWith(...a);
    let o = -1;
    const c = setInterval(() => {
      o == -1 ? a.forEach((d) => d.classList.remove(i)) : a[o]?.classList.remove(i), o += 1, o %= a.length, a[o]?.classList.add(i);
    }, 500);
    r(() => clearInterval(c));
  }), e.addInitSelector(() => e.prefixed("highlight-scroll"));
}, eo = [
  Ws,
  Gi,
  Xa,
  Qa,
  Xi,
  Ea,
  ts,
  Xs,
  La,
  Ys,
  Ba,
  Ga({
    shopify: !0,
    autoSize: !0
  }),
  Zs,
  gs,
  ys,
  ns,
  Ks,
  Gs
], to = (e) => e.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), no = (e) => e.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), ro = [
  Ir,
  to,
  no,
  Tr
];
_e.plugin([
  ...eo,
  ...ro,
  ...mi
]);
window.Alpine = _e;
var io = _e, un = () => {
};
Promise.withResolvers ??= function() {
  let e = un, t = un;
  return {
    promise: new this((n, r) => {
      e = n, t = r;
    }),
    resolve: e,
    reject: t
  };
};
Array.prototype.toSorted ??= function(e) {
  return Array.from(this).sort(e);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let e = this.nextNode();
  for (; e; )
    yield e, e = this.nextNode();
};
function er(e) {
  return ao(e, !1);
}
function ao(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    id: e.id
  };
}
function tr(e) {
  return so(e, !1);
}
function so(e, t = !1) {
  return e == null ? e : { code: e.code };
}
function F(e) {
  return oo(e, !1);
}
function oo(e, t = !1) {
  return e == null ? e : {
    initiator: e.initiator,
    pageLoadId: e.pageLoadId,
    pageUrl: e.pageUrl,
    sessionId: e.sessionId,
    timestamp: e.timestamp,
    userId: e.userId,
    attribution: e.attribution == null ? void 0 : e.attribution.map(er),
    currency: tr(e.currency),
    dev: e.dev,
    IP: e.iP,
    shopperId: e.shopperId,
    userAgent: e.userAgent
  };
}
function be(e) {
  return co(e, !1);
}
function co(e, t = !1) {
  return e == null ? e : {
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku,
    qty: e.qty,
    price: e.price
  };
}
function lo(e) {
  return uo(e, !1);
}
function uo(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(be),
    quickView: e.quickView
  };
}
function Ot(e) {
  return ho(e, !1);
}
function ho(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: lo(e.data)
  };
}
function Nt(e) {
  return fo(e, !1);
}
function fo(e, t = !1) {
  return e == null ? e : { uid: e.uid };
}
function po(e) {
  return mo(e, !1);
}
function mo(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    tag: e.tag,
    results: e.results.map(be),
    quickView: e.quickView
  };
}
function go(e) {
  return wo(e, !1);
}
function wo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: po(e.data)
  };
}
function nr(e) {
  return yo(e, !1);
}
function yo(e, t = !1) {
  return e == null ? e : { uid: e.uid };
}
function rr(e) {
  return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function ir(e) {
  return bo(e, !1);
}
function bo(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    banners: e.banners.map(nr)
  };
}
function ar(e) {
  return !(!("type" in e) || e.type === void 0 || !("parentId" in e) || e.parentId === void 0 || !("uid" in e) || e.uid === void 0);
}
function sr(e) {
  return vo(e, !1);
}
function vo(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function or(e) {
  return !(!("type" in e) || e.type === void 0 || !("uid" in e) || e.uid === void 0);
}
function cr(e) {
  return So(e, !1);
}
function So(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    uid: e.uid
  };
}
function dr(e) {
  return Io(e, !1);
}
function Io(e, t = !1) {
  return e == null || typeof e != "object" ? e : ar(e) ? sr(e) : or(e) ? cr(e) : {};
}
function lr(e) {
  return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function ur(e) {
  return To(e, !1);
}
function To(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results.map(dr),
    quickView: e.quickView
  };
}
function xo(e) {
  return Ro(e, !1);
}
function Ro(e, t = !1) {
  return e == null || typeof e != "object" ? e : rr(e) ? ir(e) : lr(e) ? ur(e) : {};
}
function Co(e) {
  return ko(e, !1);
}
function ko(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: xo(e.data)
  };
}
function At(e) {
  return Eo(e, !1);
}
function Eo(e, t = !1) {
  return e == null || typeof e != "object" ? e : ar(e) ? sr(e) : or(e) ? cr(e) : {};
}
function Oo(e) {
  return No(e, !1);
}
function No(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results == null ? void 0 : e.results.map(At),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function Ao(e) {
  return Do(e, !1);
}
function Do(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Oo(e.data)
  };
}
function Po(e) {
  return qo(e, !1);
}
function qo(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId
  };
}
function Lo(e) {
  return _o(e, !1);
}
function _o(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Po(e.data)
  };
}
function Fo(e) {
  return $o(e, !1);
}
function $o(e, t = !1) {
  return e == null ? e : {
    results: e.results.map(be),
    cart: e.cart.map(be)
  };
}
function hn(e) {
  return Jo(e, !1);
}
function Jo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Fo(e.data)
  };
}
function Mo(e) {
  return jo(e, !1);
}
function jo(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(be)
  };
}
function Bo(e) {
  return Uo(e, !1);
}
function Uo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Mo(e.data)
  };
}
function hr(e) {
  return Vo(e, !1);
}
function Vo(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function Ho(e) {
  return zo(e, !1);
}
function zo(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(hr)
  };
}
function Ko(e) {
  return Wo(e, !1);
}
function Wo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Ho(e.data)
  };
}
function Go(e) {
  return Yo(e, !1);
}
function Yo(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    feedback: e.feedback
  };
}
function Xo(e) {
  return Qo(e, !1);
}
function Qo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Go(e.data)
  };
}
function Zo(e) {
  return ec(e, !1);
}
function ec(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(hr)
  };
}
function tc(e) {
  return nc(e, !1);
}
function nc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Zo(e.data)
  };
}
function rc(e) {
  return !(!("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function ic(e) {
  return ac(e, !1);
}
function ac(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    banners: e.banners.map(nr)
  };
}
function sc(e) {
  return !(!("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function oc(e) {
  return cc(e, !1);
}
function cc(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(dr),
    quickView: e.quickView
  };
}
function dc(e) {
  return lc(e, !1);
}
function lc(e, t = !1) {
  return e == null || typeof e != "object" ? e : rc(e) ? ic(e) : sc(e) ? oc(e) : {};
}
function Dt(e) {
  return uc(e, !1);
}
function uc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: dc(e.data)
  };
}
function hc(e) {
  return fc(e, !1);
}
function fc(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(At),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function Pt(e) {
  return pc(e, !1);
}
function pc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: hc(e.data)
  };
}
function A(e) {
  return mc(e, !1);
}
function mc(e, t) {
  return e == null ? e : { success: e.success == null ? void 0 : e.success };
}
function gc(e) {
  return wc(e, !1);
}
function wc(e, t = !1) {
  return e == null ? e : {
    message: e.message,
    stack: e.stack,
    details: e.details
  };
}
function fn(e) {
  return yc(e, !1);
}
function yc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: gc(e.data)
  };
}
function bc(e) {
  return vc(e, !1);
}
function vc(e, t = !1) {
  return e == null ? e : {
    orderId: e.orderId,
    transactionTotal: e.transactionTotal,
    total: e.total,
    vat: e.vat,
    city: e.city,
    state: e.state,
    country: e.country,
    results: e.results.map(be)
  };
}
function Sc(e) {
  return Ic(e, !1);
}
function Ic(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: bc(e.data)
  };
}
function Tc(e) {
  return xc(e, !1);
}
function xc(e, t = !1) {
  return e == null ? e : {
    timestamp: e.timestamp,
    dev: e.dev
  };
}
function Rc(e) {
  return Cc(e, !1);
}
function Cc(e, t = !1) {
  return e == null ? e : {
    message: e.message,
    stack: e.stack,
    details: e.details
  };
}
function kc(e) {
  return Ec(e, !1);
}
function Ec(e, t = !1) {
  return e == null ? e : {
    context: Tc(e.context),
    data: Rc(e.data)
  };
}
function Oc(e) {
  return Nc(e, !1);
}
function Nc(e, t = !1) {
  return e == null ? e : {
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function Ac(e) {
  return Dc(e, !1);
}
function Dc(e, t = !1) {
  return e == null ? e : { result: Oc(e.result) };
}
function Pc(e) {
  return qc(e, !1);
}
function qc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Ac(e.data)
  };
}
function Lc(e) {
  return _c(e, !1);
}
function _c(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    tag: e.tag,
    results: e.results.map(be),
    quickView: e.quickView
  };
}
function Fc(e) {
  return $c(e, !1);
}
function $c(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Lc(e.data)
  };
}
function Jc(e) {
  return Mc(e, !1);
}
function Mc(e, t = !1) {
  return e == null || typeof e != "object" ? e : rr(e) ? ir(e) : lr(e) ? ur(e) : {};
}
function jc(e) {
  return Bc(e, !1);
}
function Bc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Jc(e.data)
  };
}
function Uc(e) {
  return Vc(e, !1);
}
function Vc(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results == null ? void 0 : e.results.map(At),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function Hc(e) {
  return zc(e, !1);
}
function zc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Uc(e.data)
  };
}
function Kc(e) {
  return Wc(e, !1);
}
function Wc(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId
  };
}
function Gc(e) {
  return Yc(e, !1);
}
function Yc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Kc(e.data)
  };
}
function Xc(e) {
  return Qc(e, !1);
}
function Qc(e, t = !1) {
  return e == null ? e : {
    redirect: e.redirect,
    responseId: e.responseId
  };
}
function fr(e) {
  return Zc(e, !1);
}
function Zc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Xc(e.data)
  };
}
function ed(e) {
  return td(e, !1);
}
function td(e, t = !1) {
  return e == null ? e : { responseId: e.responseId };
}
function qt(e) {
  return nd(e, !1);
}
function nd(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: ed(e.data)
  };
}
function rd(e) {
  return id(e, !1);
}
function id(e, t = !1) {
  return e == null ? e : {
    initiator: e.initiator,
    pageLoadId: e.pageLoadId,
    pageUrl: e.pageUrl,
    sessionId: e.sessionId,
    shopperId: e.shopperId,
    timestamp: e.timestamp,
    userId: e.userId,
    attribution: e.attribution == null ? void 0 : e.attribution.map(er),
    currency: tr(e.currency),
    dev: e.dev,
    IP: e.iP,
    userAgent: e.userAgent
  };
}
function ad(e) {
  return sd(e, !1);
}
function sd(e, t = !1) {
  return e == null ? e : { context: rd(e.context) };
}
var od = "https://analytics.athoscommerce.net/beacon/v2".replace(/\/+$/, ""), pr = class {
  constructor(e = {}) {
    this.configuration = e;
  }
  set config(e) {
    this.configuration = e;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : od;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || gr;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const e = this.configuration.apiKey;
    if (e) return typeof e == "function" ? e : () => e;
  }
  get accessToken() {
    const e = this.configuration.accessToken;
    if (e) return typeof e == "function" ? e : async () => e;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}, cd = new pr(), X = class mr {
  constructor(t = cd) {
    this.configuration = t, this.fetchApi = async (n, r) => {
      let i = {
        url: n,
        init: r
      };
      for (const a of this.middleware) a.pre && (i = await a.pre({
        fetch: this.fetchApi,
        ...i
      }) || i);
      let s;
      try {
        s = await (this.configuration.fetchApi || fetch)(i.url, i.init);
      } catch (a) {
        for (const o of this.middleware) o.onError && (s = await o.onError({
          fetch: this.fetchApi,
          url: i.url,
          init: i.init,
          error: a,
          response: s ? s.clone() : void 0
        }) || s);
        if (s === void 0)
          throw a instanceof Error ? new hd(a, "The request failed and the interceptors did not return an alternative response") : a;
      }
      for (const a of this.middleware) a.post && (s = await a.post({
        fetch: this.fetchApi,
        url: i.url,
        init: i.init,
        response: s.clone()
      }) || s);
      return s;
    }, this.middleware = t.middleware;
  }
  withMiddleware(...t) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...t), n;
  }
  withPreMiddleware(...t) {
    const n = t.map((r) => ({ pre: r }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...t) {
    const n = t.map((r) => ({ post: r }));
    return this.withMiddleware(...n);
  }
  isJsonMime(t) {
    return t ? mr.jsonRegex.test(t) : !1;
  }
  async request(t, n) {
    const { url: r, init: i } = await this.createFetchParams(t, n), s = await this.fetchApi(r, i);
    if (s && s.status >= 200 && s.status < 300) return s;
    throw new ud(s, "Response returned an error code");
  }
  async createFetchParams(t, n) {
    let r = this.configuration.basePath + t.path;
    t.query !== void 0 && Object.keys(t.query).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(t.query));
    const i = Object.assign({}, this.configuration.headers, t.headers);
    Object.keys(i).forEach((l) => i[l] === void 0 ? delete i[l] : {});
    const s = typeof n == "function" ? n : async () => n, a = {
      method: t.method,
      headers: i,
      body: t.body,
      credentials: this.configuration.credentials
    }, o = {
      ...a,
      ...await s({
        init: a,
        context: t
      })
    };
    let c;
    ld(o.body) || o.body instanceof URLSearchParams || dd(o.body) ? c = o.body : this.isJsonMime(i["Content-Type"]) ? c = JSON.stringify(o.body) : c = o.body;
    const d = {
      ...o,
      body: c
    };
    return {
      url: r,
      init: d
    };
  }
  clone() {
    const t = this.constructor, n = new t(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
};
X.jsonRegex = /* @__PURE__ */ new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
function dd(e) {
  return typeof Blob < "u" && e instanceof Blob;
}
function ld(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
var ud = class extends Error {
  constructor(e, t) {
    super(t), this.response = e, this.name = "ResponseError";
  }
}, hd = class extends Error {
  constructor(e, t) {
    super(t), this.cause = e, this.name = "FetchError";
  }
}, b = class extends Error {
  constructor(e, t) {
    super(t), this.field = e, this.name = "RequiredError";
  }
};
function gr(e, t = "") {
  return Object.keys(e).map((n) => wr(n, e[n], t)).filter((n) => n.length > 0).join("&");
}
function wr(e, t, n = "") {
  const r = n + (n.length ? `[${e}]` : e);
  if (t instanceof Array) {
    const i = t.map((s) => encodeURIComponent(String(s))).join(`&${encodeURIComponent(r)}=`);
    return `${encodeURIComponent(r)}=${i}`;
  }
  return t instanceof Set ? wr(e, Array.from(t), n) : t instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? gr(t, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(t))}`;
}
var D = class {
  constructor(e, t = (n) => n) {
    this.raw = e, this.transformer = t;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}, fd = class extends X {
  async autocompleteAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteAddtocart().');
    if (e.addtocartSchema == null) throw new b("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling autocompleteAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Ot(e.addtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async autocompleteAddtocart(e, t) {
    return await (await this.autocompleteAddtocartRaw(e, t)).value();
  }
  async autocompleteClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteClickthrough().');
    if (e.clickthroughSchema == null) throw new b("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling autocompleteClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Dt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async autocompleteClickthrough(e, t) {
    return await (await this.autocompleteClickthroughRaw(e, t)).value();
  }
  async autocompleteImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteImpression().');
    if (e.impressionSchema == null) throw new b("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling autocompleteImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.impressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async autocompleteImpression(e, t) {
    return await (await this.autocompleteImpressionRaw(e, t)).value();
  }
  async autocompleteRedirectRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteRedirect().');
    if (e.redirectSchema == null) throw new b("redirectSchema", 'Required parameter "redirectSchema" was null or undefined when calling autocompleteRedirect().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/redirect";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: fr(e.redirectSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async autocompleteRedirect(e, t) {
    return await (await this.autocompleteRedirectRaw(e, t)).value();
  }
  async autocompleteRenderRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteRender().');
    if (e.renderSchema == null) throw new b("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling autocompleteRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.renderSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async autocompleteRender(e, t) {
    return await (await this.autocompleteRenderRaw(e, t)).value();
  }
}, pd = class extends X {
  async bundlesAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesAddtocart().');
    if (e.bundlesAddtocartSchema == null) throw new b("bundlesAddtocartSchema", 'Required parameter "bundlesAddtocartSchema" was null or undefined when calling bundlesAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: go(e.bundlesAddtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async bundlesAddtocart(e, t) {
    return await (await this.bundlesAddtocartRaw(e, t)).value();
  }
  async bundlesClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesClickthrough().');
    if (e.bundlesClickthroughSchema == null) throw new b("bundlesClickthroughSchema", 'Required parameter "bundlesClickthroughSchema" was null or undefined when calling bundlesClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Co(e.bundlesClickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async bundlesClickthrough(e, t) {
    return await (await this.bundlesClickthroughRaw(e, t)).value();
  }
  async bundlesImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesImpression().');
    if (e.bundlesImpressionSchema == null) throw new b("bundlesImpressionSchema", 'Required parameter "bundlesImpressionSchema" was null or undefined when calling bundlesImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Ao(e.bundlesImpressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async bundlesImpression(e, t) {
    return await (await this.bundlesImpressionRaw(e, t)).value();
  }
  async bundlesRenderRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesRender().');
    if (e.bundlesRenderSchema == null) throw new b("bundlesRenderSchema", 'Required parameter "bundlesRenderSchema" was null or undefined when calling bundlesRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Lo(e.bundlesRenderSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async bundlesRender(e, t) {
    return await (await this.bundlesRenderRaw(e, t)).value();
  }
}, md = class extends X {
  async cartAddRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling cartAdd().');
    if (e.cartSchema == null) throw new b("cartSchema", 'Required parameter "cartSchema" was null or undefined when calling cartAdd().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/cart/add";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: hn(e.cartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async cartAdd(e, t) {
    return await (await this.cartAddRaw(e, t)).value();
  }
  async cartRemoveRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling cartRemove().');
    if (e.cartSchema == null) throw new b("cartSchema", 'Required parameter "cartSchema" was null or undefined when calling cartRemove().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/cart/remove";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: hn(e.cartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async cartRemove(e, t) {
    return await (await this.cartRemoveRaw(e, t)).value();
  }
}, gd = class extends X {
  async categoryAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling categoryAddtocart().');
    if (e.addtocartSchema == null) throw new b("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling categoryAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Ot(e.addtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async categoryAddtocart(e, t) {
    return await (await this.categoryAddtocartRaw(e, t)).value();
  }
  async categoryClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling categoryClickthrough().');
    if (e.clickthroughSchema == null) throw new b("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling categoryClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Dt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async categoryClickthrough(e, t) {
    return await (await this.categoryClickthroughRaw(e, t)).value();
  }
  async categoryImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling categoryImpression().');
    if (e.impressionSchema == null) throw new b("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling categoryImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.impressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async categoryImpression(e, t) {
    return await (await this.categoryImpressionRaw(e, t)).value();
  }
  async categoryRenderRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling categoryRender().');
    if (e.renderSchema == null) throw new b("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling categoryRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.renderSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async categoryRender(e, t) {
    return await (await this.categoryRenderRaw(e, t)).value();
  }
}, wd = class extends X {
  async chatAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling chatAddtocart().');
    if (e.chatAddtocartSchema == null) throw new b("chatAddtocartSchema", 'Required parameter "chatAddtocartSchema" was null or undefined when calling chatAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Bo(e.chatAddtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async chatAddtocart(e, t) {
    return await (await this.chatAddtocartRaw(e, t)).value();
  }
  async chatClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling chatClickthrough().');
    if (e.chatClickthroughSchema == null) throw new b("chatClickthroughSchema", 'Required parameter "chatClickthroughSchema" was null or undefined when calling chatClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Ko(e.chatClickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async chatClickthrough(e, t) {
    return await (await this.chatClickthroughRaw(e, t)).value();
  }
  async chatFeedbackRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling chatFeedback().');
    if (e.chatFeedbackSchema == null) throw new b("chatFeedbackSchema", 'Required parameter "chatFeedbackSchema" was null or undefined when calling chatFeedback().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/feedback";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Xo(e.chatFeedbackSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async chatFeedback(e, t) {
    return await (await this.chatFeedbackRaw(e, t)).value();
  }
  async chatImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling chatImpression().');
    if (e.chatImpressionSchema == null) throw new b("chatImpressionSchema", 'Required parameter "chatImpressionSchema" was null or undefined when calling chatImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: tc(e.chatImpressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async chatImpression(e, t) {
    return await (await this.chatImpressionRaw(e, t)).value();
  }
}, yd = class extends X {
  async logPersonalizationRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling logPersonalization().');
    if (e.personalizationLogSchema == null) throw new b("personalizationLogSchema", 'Required parameter "personalizationLogSchema" was null or undefined when calling logPersonalization().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/personalization";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: kc(e.personalizationLogSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async logPersonalization(e, t) {
    return await (await this.logPersonalizationRaw(e, t)).value();
  }
  async logShopifypixelRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling logShopifypixel().');
    if (e.logSchema == null) throw new b("logSchema", 'Required parameter "logSchema" was null or undefined when calling logShopifypixel().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/shopifypixel";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: fn(e.logSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async logShopifypixel(e, t) {
    return await (await this.logShopifypixelRaw(e, t)).value();
  }
  async logSnapRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling logSnap().');
    if (e.logSchema == null) throw new b("logSchema", 'Required parameter "logSchema" was null or undefined when calling logSnap().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/snap";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: fn(e.logSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async logSnap(e, t) {
    return await (await this.logSnapRaw(e, t)).value();
  }
};
var bd = class extends X {
  async orderTransactionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling orderTransaction().');
    if (e.orderTransactionSchema == null) throw new b("orderTransactionSchema", 'Required parameter "orderTransactionSchema" was null or undefined when calling orderTransaction().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/order/transaction";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Sc(e.orderTransactionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async orderTransaction(e, t) {
    return await (await this.orderTransactionRaw(e, t)).value();
  }
}, vd = class extends X {
  async productPageviewRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling productPageview().');
    if (e.productPageviewSchema == null) throw new b("productPageviewSchema", 'Required parameter "productPageviewSchema" was null or undefined when calling productPageview().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/product/pageview";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pc(e.productPageviewSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async productPageview(e, t) {
    return await (await this.productPageviewRaw(e, t)).value();
  }
}, Sd = class extends X {
  async recommendationsAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsAddtocart().');
    if (e.recommendationsAddtocartSchema == null) throw new b("recommendationsAddtocartSchema", 'Required parameter "recommendationsAddtocartSchema" was null or undefined when calling recommendationsAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Fc(e.recommendationsAddtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async recommendationsAddtocart(e, t) {
    return await (await this.recommendationsAddtocartRaw(e, t)).value();
  }
  async recommendationsClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsClickthrough().');
    if (e.recommendationsClickthroughSchema == null) throw new b("recommendationsClickthroughSchema", 'Required parameter "recommendationsClickthroughSchema" was null or undefined when calling recommendationsClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: jc(e.recommendationsClickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async recommendationsClickthrough(e, t) {
    return await (await this.recommendationsClickthroughRaw(e, t)).value();
  }
  async recommendationsImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsImpression().');
    if (e.recommendationsImpressionSchema == null) throw new b("recommendationsImpressionSchema", 'Required parameter "recommendationsImpressionSchema" was null or undefined when calling recommendationsImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Hc(e.recommendationsImpressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async recommendationsImpression(e, t) {
    return await (await this.recommendationsImpressionRaw(e, t)).value();
  }
  async recommendationsRenderRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsRender().');
    if (e.recommendationsRenderSchema == null) throw new b("recommendationsRenderSchema", 'Required parameter "recommendationsRenderSchema" was null or undefined when calling recommendationsRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Gc(e.recommendationsRenderSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async recommendationsRender(e, t) {
    return await (await this.recommendationsRenderRaw(e, t)).value();
  }
}, Id = class extends X {
  async searchAddtocartRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling searchAddtocart().');
    if (e.addtocartSchema == null) throw new b("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling searchAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Ot(e.addtocartSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async searchAddtocart(e, t) {
    return await (await this.searchAddtocartRaw(e, t)).value();
  }
  async searchClickthroughRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling searchClickthrough().');
    if (e.clickthroughSchema == null) throw new b("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling searchClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Dt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async searchClickthrough(e, t) {
    return await (await this.searchClickthroughRaw(e, t)).value();
  }
  async searchImpressionRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling searchImpression().');
    if (e.impressionSchema == null) throw new b("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling searchImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.impressionSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async searchImpression(e, t) {
    return await (await this.searchImpressionRaw(e, t)).value();
  }
  async searchRedirectRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling searchRedirect().');
    if (e.redirectSchema == null) throw new b("redirectSchema", 'Required parameter "redirectSchema" was null or undefined when calling searchRedirect().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/redirect";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: fr(e.redirectSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async searchRedirect(e, t) {
    return await (await this.searchRedirectRaw(e, t)).value();
  }
  async searchRenderRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling searchRender().');
    if (e.renderSchema == null) throw new b("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling searchRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.renderSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async searchRender(e, t) {
    return await (await this.searchRenderRaw(e, t)).value();
  }
}, Td = class extends X {
  async loginRaw(e, t) {
    if (e.siteId == null) throw new b("siteId", 'Required parameter "siteId" was null or undefined when calling login().');
    if (e.shopperLoginSchema == null) throw new b("shopperLoginSchema", 'Required parameter "shopperLoginSchema" was null or undefined when calling login().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/shopper/login";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: ad(e.shopperLoginSchema)
    }, t);
    return new D(s, (a) => A(a));
  }
  async login(e, t) {
    return await (await this.loginRaw(e, t)).value();
  }
}, xd = "@athoscommerce/beacon", Rd = "1.2.3", Cd = "athoscommerce";
var kd = "Javascript library for utilizing Athos Commerce beacon tracking.", Ed = "dist/cjs/src/index.js", Od = "dist/esm/src/index.js", Nd = {
  type: "git",
  url: "https://github.com/AthosCommerce/beacon.js.git"
}, Ad = "@searchspring/prettier", Dd = {
  build: "rm -rf ./dist && npm run generate && tsc && tsc -p tsconfig.cjs.json && npm run build:cdn",
  "build:cdn": "webpack --config webpack.prod.js",
  dev: "tsc --watch & webpack serve --config webpack.dev.js",
  commit: "cz",
  test: "jest",
  "test:watch": "jest --watch",
  generate: "rm -fr ./src/client && openapi-generator-cli generate -i ./beacon.v2.snap.types.oas.yaml -g typescript-fetch -o ./src/client && npm run format",
  format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
  lint: "eslint src --ext .ts,.tsx",
  prepare: "husky",
  version: "standard-version -a",
  postpublish: "git push && git push --tags"
}, Pd = { uuid: "9.0.1" }, qd = {
  "@babel/core": "^7.21.4",
  "@babel/preset-env": "^7.21.4",
  "@babel/runtime": "^7.21.0",
  "@openapitools/openapi-generator-cli": "^2.25.2",
  "@searchspring/browserslist-config-snap": "^1.0.7",
  "@searchspring/prettier": "1.0.2",
  "@types/jest": "^29.5.14",
  "@types/uuid": "^10.0.0",
  "babel-loader": "^9.1.2",
  "cz-conventional-changelog": "3.3.0",
  eslint: "9.23.0",
  "eslint-config-prettier": "10.1.1",
  husky: "9.1.7",
  jest: "29.7.0",
  "jest-environment-jsdom": "^29.7.0",
  jsdom: "26.0.0",
  "lint-staged": "15.5.0",
  prettier: "3.5.3",
  "standard-version": "9.5.0",
  "ts-jest": "^29.3.0",
  "ts-loader": "9.4.2",
  typedoc: "0.28.1",
  typescript: "5.8.2",
  "typescript-eslint": "^8.55.0",
  webpack: "^5.77.0",
  "webpack-cli": "^5.0.1",
  "webpack-dev-server": "^4.13.2",
  "webpack-merge": "^5.8.0",
  "whatwg-fetch": "^3.6.20"
}, Ld = { commitizen: { path: "./node_modules/cz-conventional-changelog" } }, _d = { universal: "extends @searchspring/browserslist-config-snap/universal" }, Fd = {
  name: xd,
  version: Rd,
  author: Cd,
  license: "MIT",
  description: kd,
  main: Ed,
  module: Od,
  repository: Nd,
  prettier: Ad,
  scripts: Dd,
  dependencies: Pd,
  devDependencies: qd,
  "lint-staged": { "*.{js,ts,tsx}": ["prettier --write", "eslint"] },
  config: Ld,
  browserslist: _d
};
function $d() {
  return {
    cookies: function() {
      return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
    },
    storage: function() {
      const e = "ss-test";
      if (typeof window > "u") return !1;
      try {
        return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
      } catch {
        return !1;
      }
    }
  };
}
var pn = $d(), Ge = {
  cookies: pn.cookies(),
  storage: pn.storage()
}, mn = (e, t, n, r, i) => {
  const s = window.location.protocol == "https:" ? "Secure;" : "", a = "SameSite=" + (n || "Lax") + ";";
  let o = "";
  if (r) {
    const u = /* @__PURE__ */ new Date();
    u.setTime(u.getTime() + r), o = "expires=" + u.toUTCString() + ";";
  }
  const c = encodeURIComponent(t) + ";";
  if (i) return e + "=" + c + o + a + s + "path=/; domain=" + i;
  const d = window?.location?.hostname;
  if (!d || d.split(".").length === 1) return e + "=" + c + o + a + s + "path=/";
  const l = d.split(".");
  return l.shift(), i = "." + l.join("."), e + "=" + c + o + a + s + "path=/; domain=" + i;
}, Ve, Jd = /* @__PURE__ */ new Uint8Array(16);
function Md() {
  if (!Ve && (Ve = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ve))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ve(Jd);
}
var M = [];
for (let e = 0; e < 256; ++e) M.push((e + 256).toString(16).slice(1));
function jd(e, t = 0) {
  return M[e[t + 0]] + M[e[t + 1]] + M[e[t + 2]] + M[e[t + 3]] + "-" + M[e[t + 4]] + M[e[t + 5]] + "-" + M[e[t + 6]] + M[e[t + 7]] + "-" + M[e[t + 8]] + M[e[t + 9]] + "-" + M[e[t + 10]] + M[e[t + 11]] + M[e[t + 12]] + M[e[t + 13]] + M[e[t + 14]] + M[e[t + 15]];
}
var Bd = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), gn = { randomUUID: Bd };
function Ud(e, t, n) {
  if (gn.randomUUID && !t && !e) return gn.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || Md)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i) t[n + i] = r[i];
    return t;
  }
  return jd(r);
}
var { version: Vd } = Fd;
var He = 47304e6, wn = 18e5;
var Hd = 20, zd = -1, le = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, yr = "userId", Ne = "pageLoadId", Ye = "sessionId", he = "shopperId", ae = "cartProducts", se = "viewedProducts", fe = "attribution", ut = {
  [yr]: {
    primary: "athosUserId",
    legacy: "ssUserId"
  },
  [Ne]: {
    primary: "athosPageLoadId",
    legacy: "ssPageLoadId"
  },
  [Ye]: {
    primary: "athosSessionId",
    legacy: "ssSessionId"
  },
  [he]: {
    primary: "athosShopperId",
    legacy: "ssShopperId"
  },
  [ae]: {
    primary: "athosCartProducts",
    legacy: "ssCartProducts"
  },
  [se]: {
    primary: "athosViewedProducts",
    legacy: "ssViewedProducts"
  },
  [fe]: {
    primary: "athosAttribution",
    legacy: "ssAttribution"
  }
}, Kd = class {
  constructor(e, t) {
    if (this.mode = "production", this.pageLoadId = "", this.userId = "", this.sessionId = "", this.shopperId = "", this.currency = { code: "" }, this.initiator = "", this.batchIntervalTimeout = 0, this.preflightTimeout = 0, this.requests = [], this.storage = {
      cart: {
        get: () => {
          const a = this.getLocalStorageItem(ae);
          if (a) try {
            if (Array.isArray(a)) return a;
          } catch {
            vn(ae), this.setCookie(ae, "", "Lax", 0, le);
          }
          else return this.getCookie(ae).split(",").filter((o) => o).map((o) => ({
            parentId: o,
            uid: o,
            sku: o,
            qty: 1,
            price: 0
          }));
          return [];
        },
        set: (a) => {
          const o = this.storage.cart.get(), c = JSON.stringify(a);
          try {
            this.setLocalStorageItem(ae, a);
          } catch (l) {
            Ie(l, this, ae, c);
          }
          const d = a.map((l) => this.getProductId(l)).join(",");
          this.setCookie(ae, d, "Lax", 0, le), JSON.stringify(o) !== c && this._sendPreflight();
        },
        add: (a) => {
          if (a.length) {
            const o = [...this.storage.cart.get()];
            a.filter((c) => typeof c == "object" && c.uid).reverse().forEach((c) => {
              const d = o.find((l) => l.uid === c.uid);
              d ? (d.qty += c.qty, d.price = c.price || d.price, (c.parentId !== d.parentId || c.sku !== d.sku) && (d.parentId = c.parentId, d.sku = c.sku)) : o.unshift(c);
            }), this.storage.cart.set(o);
          }
        },
        remove: (a) => {
          if (a.length) {
            const o = [...this.storage.cart.get()];
            a.forEach((d) => {
              const l = o.find((u) => u.uid === d.uid);
              l && l.qty > 0 && (l.qty -= d.qty || 1, (d.parentId !== l.parentId || d.sku !== l.sku) && (l.parentId = d.parentId, l.sku = d.sku));
            });
            const c = o.filter((d) => d.qty > 0);
            this.storage.cart.set(c);
          }
        },
        clear: () => {
          this.storage.cart.set([]);
        }
      },
      viewed: {
        get: () => {
          const a = this.getLocalStorageItem(se);
          if (a) try {
            if (Array.isArray(a)) return a;
          } catch {
            vn(se), this.setCookie(se, "", "Lax", He, le);
          }
          else return this.getCookie(se).split(",").filter((o) => o).map((o) => ({
            parentId: o,
            uid: o,
            sku: o
          }));
          return [];
        },
        set: (a) => {
          const o = this.storage.viewed.get(), c = a.map((u) => ({
            sku: u.sku,
            parentId: u.parentId,
            uid: u.uid
          })).slice(0, Hd), d = JSON.stringify(c);
          try {
            this.setLocalStorageItem(se, c);
          } catch (u) {
            Ie(u, this, se, d);
          }
          const l = c.map((u) => this.getProductId(u)).join(",");
          this.setCookie(se, l, "Lax", He, le), JSON.stringify(o) !== d && this._sendPreflight();
        },
        add: (a) => {
          if (a.length) {
            const o = this.storage.viewed.get();
            a.forEach((c) => {
              const d = {
                sku: c.sku,
                parentId: c.parentId,
                uid: c.uid
              }, l = o.find((u) => u.uid === d.uid);
              if (l) {
                const u = o.indexOf(l);
                o.splice(u, 1);
              }
              o.unshift(d);
            }), this.storage.viewed.set(o);
          }
        }
      }
    }, this.events = {
      shopper: { login: (a) => {
        const o = this.getContext();
        if (!o.shopperId || o.shopperId !== a.data.id) {
          this.setShopperId(a.data.id);
          return;
        }
        if (o.shopperId = a.data?.id, a.data?.id) {
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            shopperLoginSchema: { context: o }
          }, d = this.createRequest("shopper", "login", c);
          this.queueRequest(d);
        }
      } },
      autocomplete: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteClickthrough", o);
          this.sendRequests([c]);
        },
        redirect: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            redirectSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteRedirect", o);
          this.sendRequests([c]);
        }
      },
      search: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchClickthrough", o);
          this.sendRequests([c]);
        },
        redirect: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            redirectSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchRedirect", o);
          this.sendRequests([c]);
        }
      },
      category: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryClickthrough", o);
          this.sendRequests([c]);
        }
      },
      bundles: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesRenderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesClickthrough", o);
          this.sendRequests([c]);
        }
      },
      chat: {
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatClickthrough", o);
          this.sendRequests([c]);
        },
        feedback: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatFeedbackSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatFeedback", o);
          this.sendRequests([c]);
        }
      },
      recommendations: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsRenderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsClickthrough", o);
          this.sendRequests([c]);
        }
      },
      product: { pageView: (a) => {
        const o = {
          siteId: a?.siteId || this.globals.siteId,
          productPageviewSchema: {
            context: this.getContext(),
            data: a.data
          }
        }, c = this.createRequest("product", "productPageview", o);
        this.sendRequests([c]);
        const d = a.data.result;
        this.storage.viewed.add([d]);
      } },
      cart: {
        add: (a) => {
          const o = { ...a.data };
          o.cart ? this.storage.cart.set(o.cart) : (o.results && this.storage.cart.add(o.results), o.cart = this.storage.cart.get());
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            cartSchema: {
              context: this.getContext(),
              data: o
            }
          }, d = this.createRequest("cart", "cartAdd", c);
          this.sendRequests([d]);
        },
        remove: (a) => {
          const o = { ...a.data };
          o.cart ? this.storage.cart.set(o.cart) : (o.results && this.storage.cart.remove(o.results), o.cart = this.storage.cart.get());
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            cartSchema: {
              context: this.getContext(),
              data: o
            }
          }, d = this.createRequest("cart", "cartRemove", c);
          this.sendRequests([d]);
        }
      },
      order: { transaction: (a) => {
        const o = {
          siteId: a?.siteId || this.globals.siteId,
          orderTransactionSchema: {
            context: this.getContext(),
            data: a.data
          }
        }, c = this.createRequest("order", "orderTransaction", o);
        this.sendRequests([c]), this.storage.cart.clear();
      } },
      error: {
        shopifypixel: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            logSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("error", "logShopifypixel", o);
          this.sendRequests([c]);
        },
        snap: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            logSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("error", "logSnap", o);
          this.sendRequests([c]);
        }
      }
    }, typeof e != "object" || typeof e.siteId != "string") throw new Error('Invalid config passed to tracker. The "siteId" attribute must be provided.');
    this.config = {
      mode: "production",
      ...t || {}
    }, this.config.mode && ["production", "development"].includes(this.config.mode) && (this.mode = this.config.mode);
    const n = this.config.apis?.fetch, r = `${e.siteId}`.trim().toLowerCase().startsWith("at") ? "athos" : "searchspring", i = r === "searchspring" ? "https://analytics.searchspring.net/beacon/v2" : void 0, s = new pr({
      fetchApi: n,
      basePath: this.config.requesters?.beacon?.origin || i,
      headers: { "Content-Type": "text/plain" }
    });
    if (this.apis = {
      shopper: new Td(s),
      autocomplete: new fd(s),
      search: new Id(s),
      category: new gd(s),
      recommendations: new Sd(s),
      bundles: new pd(s),
      chat: new wd(s),
      product: new vd(s),
      cart: new md(s),
      order: new bd(s),
      error: new yd(s)
    }, this.initiator = this.config.initiator || `${r}/beaconjs/${Vd}`, this.globals = e, this.pageLoadId = this.getPageLoadId(), this.globals?.siteId) this.globals.siteId = `${this.globals.siteId}`.trim().toLowerCase();
    else throw new Error("Beacon: No siteId found in globals. Beacon will not initialize.");
  }
  setCookie(e, t, n, r, i) {
    Ge.cookies && bn(e, this.globals.siteId).forEach((s) => {
      try {
        if (window.document.cookie = mn(s, t, n, r, i), yt(s) == null || yt(s) != t) {
          const a = "." + window.location.hostname;
          window.document.cookie = mn(s, t, n, r, a);
        }
      } catch (a) {
        console.error(`Failed to set '${s}' cookie:`, a);
      }
    });
  }
  getLocalStorageItem(e) {
    const t = yn(e, this.globals.siteId);
    if (typeof window < "u" && Ge.storage) {
      let n = "";
      for (const r of t) {
        const i = window.localStorage.getItem(r);
        if (i) {
          n = i;
          break;
        }
      }
      try {
        const r = JSON.parse(n);
        if (r && r.value) return r.value;
        t.forEach((i) => {
          window.localStorage.removeItem(i);
        });
      } catch {
      }
    }
  }
  setLocalStorageItem(e, t) {
    const n = bn(e, this.globals.siteId);
    if (typeof window < "u" && Ge.storage) try {
      const r = JSON.stringify({ value: t });
      n.forEach((i) => {
        window.localStorage.setItem(i, r);
      });
    } catch (r) {
      throw console.warn(`Something went wrong setting local storage item '${e}':`, r), r;
    }
  }
  getCookie(e) {
    const t = yn(e, this.globals.siteId);
    for (const n of t) {
      const r = yt(n);
      if (r) return r;
    }
    return "";
  }
  queueRequest(e) {
    this.requests.push(e), clearTimeout(this.batchIntervalTimeout), this.batchIntervalTimeout = setTimeout(() => {
      this.processRequests();
    }, 300);
  }
  updateContext(e, t) {
    if (t !== void 0)
      switch (e) {
        case yr:
        case Ye:
        case he:
        case Ne:
        case fe:
          this[e] = t;
          break;
        case "pageUrl":
          this.config.href = t;
          break;
        case "userAgent":
          this.config.userAgent = t;
          break;
        case "dev":
          ["production", "development"].includes(t) && (this.mode = t);
      }
  }
  getContext() {
    const e = {
      userAgent: this.config.userAgent,
      timestamp: this.getTimestamp(),
      pageUrl: this.config.href || typeof window < "u" && window.location.href || "",
      userId: this.userId || this.getUserId(),
      sessionId: this.sessionId || this.getSessionId(),
      pageLoadId: this.pageLoadId,
      shopperId: this.shopperId || this.getShopperId(),
      initiator: this.initiator,
      dev: this.mode === "development" ? !0 : void 0,
      attribution: this.attribution || this.getAttribution()
    };
    return this.currency.code && (e.currency = { ...this.currency }), e;
  }
  getStoredId(e, t) {
    let n = "", r = "";
    try {
      r = this.getCookie(e);
      const s = this.getLocalStorageItem(e);
      s.timestamp && new Date(s.timestamp).getTime() < Date.now() - t ? (n = this.generateId(), this.attribution = void 0) : n = s.value;
    } catch {
    }
    const i = {
      value: r || n || this.generateId(),
      timestamp: this.getTimestamp()
    };
    e === "userId" && (this.userId = i.value), e === Ye && (this.sessionId = i.value), this.setCookie(e, i.value, "Lax", zd, le), this.setCookie(e, i.value, "Lax", t);
    try {
      this.setLocalStorageItem(e, i);
    } catch (s) {
      Ie(s, this, e, i.value);
    }
    return i.value;
  }
  getPageLoadId() {
    if (this.pageLoadId) return this.pageLoadId;
    let e = this.generateId();
    const t = this.getLocalStorageItem(Ne), n = this.config.href || typeof window < "u" && window.location.href || "";
    if (t) {
      const { href: r, value: i, timestamp: s } = t;
      r === n && i && s && new Date(s).getTime() > Date.now() - 1e4 && (e = i);
    }
    this.pageLoadId = e;
    try {
      this.setLocalStorageItem(Ne, {
        href: n,
        value: e,
        timestamp: this.getTimestamp()
      });
    } catch (r) {
      Ie(r, this, Ne, e);
    }
    return e;
  }
  getUserId() {
    return this.userId || this.getStoredId("userId", He);
  }
  getSessionId() {
    return this.sessionId || this.getStoredId(Ye, wn);
  }
  getShopperId() {
    try {
      const e = this.getCookie(he), t = this.getLocalStorageItem(he), n = e || (t ? "" + t : void 0);
      n && (this.shopperId = n);
    } catch {
    }
    return this.shopperId || "";
  }
  setShopperId(e) {
    if (!e) return;
    const t = this.getShopperId();
    this.shopperId = "" + e, this.setCookie(he, this.shopperId, "Lax", He, le);
    try {
      this.setLocalStorageItem(he, this.shopperId);
    } catch (n) {
      Ie(n, this, he, this.shopperId);
    }
    t !== e && (this.events.shopper.login({ data: { id: this.shopperId } }), this._sendPreflight());
  }
  getAttribution() {
    let e = [], t = null;
    try {
      const r = new URL(this.config.href || typeof window < "u" && window.location.href || "");
      t = r.searchParams.get("athos_attribution") || r.searchParams.get("ss_attribution");
    } catch {
    }
    const n = this.getCookie(fe) || this.getLocalStorageItem(fe);
    if (n) try {
      typeof n == "string" ? e = JSON.parse(n) : Array.isArray(n) && (e = n);
    } catch {
    }
    if (t) try {
      const [r, i] = decodeURIComponent(t).split(":");
      r && i && !e.find((s) => s.type === r && s.id === i) && e.unshift({
        type: r,
        id: i
      });
    } catch {
    }
    if (e.length) {
      const r = JSON.stringify(e);
      this.setCookie(fe, r, "Lax", wn, le);
      try {
        this.setLocalStorageItem(fe, e);
      } catch (i) {
        Ie(i, this, fe, r);
      }
      return this.attribution = e, [...e];
    }
  }
  generateId() {
    return Ud();
  }
  getTimestamp() {
    return (/* @__PURE__ */ new Date()).toISOString();
  }
  setCurrency(e) {
    e && e.code && this.currency?.code !== e.code && (this.currency = e);
  }
  pageLoad() {
    return this.pageLoadId = this.generateId(), this.pageLoadId;
  }
  createRequest(e, t, n) {
    return {
      apiType: e,
      endpoint: t,
      payload: n
    };
  }
  getApiClient(e) {
    return this.apis[e];
  }
  sendRequests(e) {
    for (const t of e) {
      const n = this.getApiClient(t.apiType), r = t.endpoint, i = async ({ init: s }) => {
        const a = {
          ...s.headers,
          ...this.config.requesters?.beacon?.headers || {}
        }, o = a && "Content-Type" in a && a["Content-Type"] === "application/json";
        return {
          keepalive: this.mode === "production" ? !0 : void 0,
          body: o ? s.body : JSON.stringify(s.body),
          headers: a
        };
      };
      n[r](t.payload, i).catch((s) => {
        this.mode === "development" && console.debug(s);
      });
    }
  }
  processRequests() {
    const e = this.requests.reduce((n, r) => {
      let i = `${r.payload.siteId}||${r.endpoint}`;
      switch (r.endpoint) {
        case "recommendationsAddtocart": {
          const s = r.payload.recommendationsAddtocartSchema;
          i += K("recommendation", s), z(n, i, "recommendationsAddtocartSchema", r);
          break;
        }
        case "recommendationsImpression": {
          const s = r.payload.recommendationsImpressionSchema;
          i += K("recommendation", s), z(n, i, "recommendationsImpressionSchema", r);
          break;
        }
        case "bundlesAddtocart": {
          const s = r.payload.bundlesAddtocartSchema;
          i += K("bundle", s), z(n, i, "bundlesAddtocartSchema", r);
          break;
        }
        case "bundlesImpression": {
          const s = r.payload.bundlesImpressionSchema;
          i += K("bundle", s), z(n, i, "bundlesImpressionSchema", r);
          break;
        }
        case "chatAddtocart": {
          const s = r.payload.chatAddtocartSchema;
          i += K("chat", s), z(n, i, "chatAddtocartSchema", r);
          break;
        }
        case "chatImpression": {
          const s = r.payload.chatImpressionSchema;
          i += K("chat", s), z(n, i, "chatImpressionSchema", r);
          break;
        }
        case "searchAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("search", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "searchImpression": {
          const s = r.payload.impressionSchema;
          i += K("search", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "autocompleteAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("autocomplete", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "autocompleteImpression": {
          const s = r.payload.impressionSchema;
          i += K("autocomplete", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "categoryAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("category", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "categoryImpression": {
          const s = r.payload.impressionSchema;
          i += K("category", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "login": {
          const s = r.payload.shopperLoginSchema;
          i += K("shopper", s), z(n, i, "shopperLoginSchema", r);
          break;
        }
        default:
          n.nonBatched.push(r);
      }
      return n;
    }, {
      nonBatched: [],
      batches: {}
    });
    this.requests = [];
    const t = Object.values(e.batches).reduce((n, r) => (n.push(r), n), e.nonBatched);
    this.sendRequests(t);
  }
  _sendPreflight() {
    clearTimeout(this.preflightTimeout), this.preflightTimeout = setTimeout(() => {
      this.sendPreflight();
    }, 300);
  }
  sendPreflight(e) {
    const t = e?.userId || this.getUserId(), n = e?.siteId || this.globals.siteId, r = e?.shopper || this.getShopperId(), i = e?.cart || this.storage.cart.get(), s = e?.lastViewed || this.storage.viewed.get();
    if (t && typeof t == "string" && n) {
      const a = {
        userId: t,
        siteId: n
      };
      r && (a.shopper = r), i.length && (a.cart = i.map((d) => this.getProductId(d))), s.length && (a.lastViewed = s.map((d) => this.getProductId(d)));
      const o = `${n}`.toLowerCase().startsWith("at") ? "athoscommerce.net" : "searchspring.io", c = `${this.config.requesters?.personalization?.origin || `https://${n}.a.${o}`}/v1/preflight`;
      (this.config.apis?.fetch || typeof fetch < "u") && (this.config.apis?.fetch || fetch)(c, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          ...this.config.requesters?.personalization?.headers || {}
        },
        body: JSON.stringify(a),
        keepalive: !0
      });
    }
  }
  getProductId(e) {
    return `${e.sku || e.uid || ""}`.trim();
  }
};
function z(e, t, n, r) {
  if (!e.batches[t]) e.batches[t] = JSON.parse(JSON.stringify(r));
  else {
    const i = e.batches[t].payload, s = r.payload, a = i[n], o = s[n];
    if (o?.data?.results) {
      const c = a.data.results || [], d = o.data.results, l = [...c, ...d];
      a.data.results = l;
    }
    if (o?.data?.banners) {
      const c = a?.data?.banners || [], d = o.data.banners, l = [...c, ...d];
      a.data.banners = l;
    }
  }
}
function K(e, t) {
  let n = "";
  return n += `||${t.context.pageLoadId}`, n += `||${t.context.sessionId}`, t.data?.chatSessionId ? n += `||chatSessionId=${t.data.chatSessionId}||responseId=${t.data.responseId}` : t.data?.responseId ? n += `||responseId=${t.data.responseId}` : e === "shopper" && t.context.shopperId && (n += `||shopperId=${t.context.shopperId}`), (e === "recommendation" || e === "bundle") && (n += `||tag=${t.data.tag}`), n;
}
function yt(e) {
  if (typeof window < "u" && Ge.cookies) {
    const t = e + "=", n = window.document.cookie.split(";");
    for (let r = 0; r < n.length; r++) {
      let i = n[r];
      for (; i.charAt(0) == " "; ) i = i.substring(1);
      if (i.indexOf(t) == 0) return decodeURIComponent(i.substring(t.length, i.length));
    }
    return "";
  }
  return "";
}
function yn(e, t) {
  const n = ut[e];
  return t.trim().toLowerCase().startsWith("at") ? [n.primary, n.legacy] : [n.legacy, n.primary];
}
function bn(e, t) {
  const n = ut[e];
  return t.trim().toLowerCase().startsWith("at") ? [n.primary] : [n.legacy];
}
function vn(e) {
  const t = ut[e];
  typeof window < "u" && (window.localStorage?.removeItem(t.primary), window.localStorage?.removeItem(t.legacy));
}
function Ie(e, t, n, r) {
  if (e instanceof Error && e.name === "QuotaExceededError") {
    const i = ut[n];
    t.events.error.snap({ data: {
      message: "QuotaExceededError",
      details: {
        key: i.legacy,
        keyPrimary: i.primary,
        value: r
      }
    } });
  }
}
var ht = class {
  siteId;
  constructor(e) {
    this.siteId = e.siteId;
  }
  dispatch(e, t) {
    return this;
  }
  async context() {
    return null;
  }
}, Wd = class extends ht {
  beacon;
  shopper;
  constructor(e) {
    super(e), this.beacon = new Kd({ siteId: e.siteId });
    const t = window.Shopify?.currency?.active;
    t && this.beacon.setCurrency({ code: t }), this.shopper = e.shopperId ? `${e.shopperId}` : null, this.shopper && this.beacon.updateContext("shopperId", this.shopper);
  }
  dispatch(e, t) {
    return Xd[e]?.(this.beacon, t), this;
  }
  async context() {
    const { userId: e, sessionId: t, pageLoadId: n } = this.beacon.getContext();
    if (!e || !t || !n) return null;
    const r = window.Alpine?.store("cart").items, i = (r?.length ? r : this.beacon.storage.cart.get()).map(Sn);
    return {
      userId: e,
      sessionId: t,
      pageLoadId: n,
      shopper: this.shopper,
      cart: [...new Set(i.filter(Boolean))],
      lastViewed: this.beacon.storage.viewed.get().map(Sn).filter(Boolean)
    };
  }
}, Sn = (e) => `${e.sku ?? e.uid ?? e.id ?? ""}`.trim(), Gd = class extends ht {
  dispatch(e, t) {
    return console.info(`[TRACKER: ${e}]
${JSON.stringify(t, null, 2)}`), this;
  }
}, It = (e) => e.type === "beacon" ? new Wd(e) : e.type === "debug" ? new Gd(e) : new ht(e), br = () => window.Shopify, In = () => br()?.customerPrivacy?.analyticsProcessingAllowed() ?? !1, Yd = class extends ht {
  config;
  tracker = null;
  pending = [];
  ready;
  constructor(e) {
    super(e), this.config = e;
    const { promise: t, resolve: n } = Promise.withResolvers();
    this.ready = t, br()?.loadFeatures?.([{
      name: "consent-tracking-api",
      version: "0.1"
    }], (r) => {
      const i = this.pending ?? [];
      if (this.pending = null, n(), !r)
        for (const [s, a] of i) this.dispatch(s, a);
    });
  }
  async context() {
    if (this.pending && await Promise.race([this.ready, new Promise((e) => setTimeout(e, 300))]), this.pending || !In()) return null;
    try {
      return this.tracker ??= It(this.config), await this.tracker.context();
    } catch (e) {
      return console.warn("[TRACKER]", e), null;
    }
  }
  dispatch(e, t) {
    if (this.pending)
      return this.pending.push([e, t]), this;
    if (!In()) return this;
    try {
      this.tracker ??= It(this.config), this.tracker.dispatch(e, t);
    } catch (n) {
      console.warn("[TRACKER]", n);
    }
    return this;
  }
}, nl = (e) => (t) => {
  const n = e.type === "beacon" ? new Yd(e) : It(e);
  t.$tracking = n, t.magic("tracking", () => n);
}, Xd = {
  AutocompleteRender: (e, t) => e.events.autocomplete.render({ data: t }),
  AutocompleteImpression: (e, t) => e.events.autocomplete.impression({ data: t }),
  AutocompleteClickThrough: (e, t) => e.events.autocomplete.clickThrough({ data: t }),
  AutocompleteAddToCart: (e, t) => e.events.autocomplete.addToCart({ data: t }),
  AutocompleteRedirect: (e, t) => e.events.autocomplete.redirect({ data: t }),
  SearchRender: (e, t) => e.events.search.render({ data: t }),
  SearchImpression: (e, t) => e.events.search.impression({ data: t }),
  SearchClickThrough: (e, t) => e.events.search.clickThrough({ data: t }),
  SearchAddToCart: (e, t) => e.events.search.addToCart({ data: t }),
  SearchRedirect: (e, t) => e.events.search.redirect({ data: t }),
  CategoryRender: (e, t) => e.events.category.render({ data: t }),
  CategoryImpression: (e, t) => e.events.category.impression({ data: t }),
  CategoryClickThrough: (e, t) => e.events.category.clickThrough({ data: t }),
  CategoryAddToCart: (e, t) => e.events.category.addToCart({ data: t }),
  RecommendationsRender: (e, t) => e.events.recommendations.render({ data: t }),
  RecommendationsImpression: (e, t) => e.events.recommendations.impression({ data: t }),
  RecommendationsClickThrough: (e, t) => e.events.recommendations.clickThrough({ data: t }),
  RecommendationsAddToCart: (e, t) => e.events.recommendations.addToCart({ data: t }),
  ProductView: (e, t) => e.events.product.pageView({ data: t }),
  CartAdd: (e, t) => e.events.cart.add({ data: t }),
  CartRemove: (e, t) => e.events.cart.remove({ data: t }),
  CustomerLogin: (e, t) => e.events.shopper.login({ data: t })
}, rl = io;
export {
  io as Alpine,
  nl as Tracking,
  rl as default
};
